export default {
    data() {
        return {
            competitions: {
                '38.04.01':{
                    UK:[{code: 'УК-1',
                        cat:"Системное и критическое мышление",
                        desc:"Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {code: 'УК-2',
                            cat:"Разработка и реализация проектов",
                            desc:"Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {code: 'УК-3',
                            cat:"Командная работа и лидерство",
                            desc:"Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {code: 'УК-4',
                            cat:"Коммуникация",
                            desc:"Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {code: 'УК-5',
                            cat:"Межкультурное взаимодействие",
                            desc:"Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {code: 'УК-6',
                            cat:"Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc:"Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],

                    OPK:[]
                },
                '38.04.02':{
                    UK:[{code: 'УК-1',
                        cat:"Системное и критическое мышление",
                        desc:"Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {code: 'УК-2',
                            cat:"Разработка и реализация проектов",
                            desc:"Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {code: 'УК-3',
                            cat:"Командная работа и лидерство",
                            desc:"Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {code: 'УК-4',
                            cat:"Коммуникация",
                            desc:"Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {code: 'УК-5',
                            cat:"Межкультурное взаимодействие",
                            desc:"Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {code: 'УК-6',
                            cat:"Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc:"Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],

                    OPK:[]
                },
                '54.04.01':{
                    UK:[{code: 'УК-1',
                        cat:"Системное и критическое мышление",
                        desc:"Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {code: 'УК-2',
                            cat:"Разработка и реализация проектов",
                            desc:"Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {code: 'УК-3',
                            cat:"Командная работа и лидерство",
                            desc:"Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {code: 'УК-4',
                            cat:"Коммуникация",
                            desc:"Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {code: 'УК-5',
                            cat:"Межкультурное взаимодействие",
                            desc:"Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {code: 'УК-6',
                            cat:"Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc:"Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],

                    OPK:[{code:'ОПК-1',
                        cat:"История и теория искусств и дизайна",
                        desc:"Способен применять знания в области истории и теории искусств, истории и теории дизайна в профессиональной деятельности; рассматривать произведения искусства и дизайна в широком культурно-историческом контексте в тесной связи с религиозными, философскими и эстетическими идеями конкретного исторического периода"
                    },
                        {code:'ОПК-2',
                            cat:"Научно-исследовательская деятельность",
                            desc:"Способен работать с научной литературой; собирать, анализировать и обобщать результаты научных исследований; оценивать полученную информацию; выполнять отдельные виды работ при проведении научных исследований с применением современных научных методов; самостоятельно обучаться; приобретать и использовать в практической деятельности новые знания и умения; участвовать в научно-практических конференциях; делать доклады и сообщения"
                        },
                        {code:'ОПК-3',
                            cat:"Проектная деятельность",
                            desc:"Способен разрабатывать концептуальную проектную идею; синтезировать набор возможных решений и научно обосновать свои предложения при проектировании дизайн-объектов, удовлетворяющих утилитарные и эстетические потребности человека (техника и оборудование, транспортные средства, интерьеры, среда, полиграфия, товары народного потребления); выдвигать и реализовывать креативные идеи"
                        },
                        {code:'ОПК-4',
                            cat:"Организаторская деятельность",
                            desc:"Способен организовывать, проводить и участвовать в художественных выставках, конкурсах, фестивалях; разрабатывать и реализовывать инновационные художественно-творческие мероприятия, презентации, инсталляции, проявлять творческую инициативу"
                        },
                        {code:'ОПК-5',
                            cat:"Педагогическая деятельность",
                            desc:"Способен осуществлять педагогическую деятельность по программам профессионального образования и дополнительного профессионального образования"
                        }]
                },
                '38.03.03':{
                    UK:[{code: 'УК-1',
                        cat:"Системное и критическое мышление",
                        desc:"Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {code: 'УК-2',
                            cat:"Разработка и реализация проектов",
                            desc:"Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {code: 'УК-3',
                            cat:"Командная работа и лидерство",
                            desc:"Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {code: 'УК-4',
                            cat:"Коммуникация",
                            desc:"Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {code: 'УК-5',
                            cat:"Межкультурное взаимодействие",
                            desc:"Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {code: 'УК-6',
                            cat:"Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc:"Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {code: 'УК-7',
                            cat:"Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc:"Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {code: 'УК-8',
                            cat:"Безопасность жизнедеятельности",
                            desc:"Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {code: 'УК-9',
                            cat:"Инклюзивная компетентность",
                            desc:"Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {code: 'УК-10',
                            cat:"Экономическая культура, в том числе финансовая грамотность",
                            desc:"Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {code: 'УК-11',
                            cat:"Гражданская позиция",
                            desc:"Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],

                    OPK:[]
                },
                '46.03.01':{
                    UK:[{code: 'УК-1',
                        cat:"Системное и критическое мышление",
                        desc:"Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {code: 'УК-2',
                            cat:"Разработка и реализация проектов",
                            desc:"Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {code: 'УК-3',
                            cat:"Командная работа и лидерство",
                            desc:"Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {code: 'УК-4',
                            cat:"Коммуникация",
                            desc:"Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {code: 'УК-5',
                            cat:"Межкультурное взаимодействие",
                            desc:"Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {code: 'УК-6',
                            cat:"Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc:"Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {code: 'УК-7',
                            cat:"Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc:"Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {code: 'УК-8',
                            cat:"Безопасность жизнедеятельности",
                            desc:"Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {code: 'УК-9',
                            cat:"Инклюзивная компетентность",
                            desc:"Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {code: 'УК-10',
                            cat:"Экономическая культура, в том числе финансовая грамотность",
                            desc:"Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {code: 'УК-11',
                            cat:"Гражданская позиция",
                            desc:"Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],

                    OPK:[]
                },
                '45.03.03':{
                    UK:[{code: 'УК-1',
                        cat:"Системное и критическое мышление",
                        desc:"Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {code: 'УК-2',
                            cat:"Разработка и реализация проектов",
                            desc:"Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {code: 'УК-3',
                            cat:"Командная работа и лидерство",
                            desc:"Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {code: 'УК-4',
                            cat:"Коммуникация",
                            desc:"Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {code: 'УК-5',
                            cat:"Межкультурное взаимодействие",
                            desc:"Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {code: 'УК-6',
                            cat:"Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc:"Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {code: 'УК-7',
                            cat:"Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc:"Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {code: 'УК-8',
                            cat:"Безопасность жизнедеятельности",
                            desc:"Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {code: 'УК-9',
                            cat:"Экономическая культура, в том числе финансовая грамотность",
                            desc:"Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {code: 'УК-10',
                            cat:"Гражданская позиция",
                            desc:"Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],

                    OPK:[{code:'ОПК-1',
                        cat:"Фундаментальные основы профессиональной деятельности",
                        desc:"Способен применять в профессиональной деятельности основные понятия и категории современной лингвистики"
                    },
                        {code:'ОПК-2',
                            cat:"Фундаментальные основы профессиональной деятельности",
                            desc:"Способен к ведению профессиональной деятельности с опорой на основы математических дисциплин, необходимых для формализации лингвистических знаний и процедур анализа и синтеза лингвистических структур"
                        },
                        {code:'ОПК-3',
                            cat:"Фундаментальные основы профессиональной деятельности",
                            desc:"Способен применять в профессиональной деятельности основы грамматики латинского языка и уметь читать со словарем латинские тексты"
                        },
                        {code:'ОПК-4',
                            cat:"Коммуникация, межкультурное взаимодействие в предметной области",
                            desc:"Способен применять кодифицированные нормы русского литературного языка и владеть его научным стилем"
                        },
                        {code:'ОПК-5',
                            cat:"Коммуникация, межкультурное взаимодействие в предметной области",
                            desc:"Способен создавать и редактировать тексты профессионального назначения"
                        },
                        {code:'ОПК-6',
                            cat:"Коммуникация, межкультурное взаимодействие в предметной области",
                            desc:"Способен свободно говорить и понимать речь на первом изучаемом иностранном языке в его литературной форме, включая профессиональное письменное и устное общение; владеть вторым иностранным языком в объеме, достаточном для профессионального общения и чтения научной литературы"
                        },
                        {code:'ОПК-7',
                            cat:"Информационно-коммуникационная культура",
                            desc:"Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                        }]
                },
                '01.03.02': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-10',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],

                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Теоретические и практические основы профессиональной деятельности",
                        desc: "Способен применять фундаментальные знания, полученные в области математических и (или) естественных наук, и использовать их в профессиональной деятельности "
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Теоретические и практические основы профессиональной деятельности",
                            desc: "Способен использовать и адаптировать существующие математические методы и системы программирования для разработки и реализации алгоритмов решения прикладных задач "
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Теоретические и практические основы профессиональной деятельности",
                            desc: "Способен применять и модифицировать математические модели для решения задач в области профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Информационно-коммуникационные технологии для профессиональной деятельности",
                            desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности "
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Информационно-коммуникационные технологии для профессиональной деятельности",
                            desc: "Способен разрабатывать алгоритмы и компьютерные программы, пригодные для практического применения"
                        }]
                },
                '13.03.01': {
                    UK:[{code: 'УК-1',
                        cat:"Системное и критическое мышление",
                        desc:"Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {code: 'УК-2',
                            cat:"Разработка и реализация проектов",
                            desc:"Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {code: 'УК-3',
                            cat:"Командная работа и лидерство",
                            desc:"Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {code: 'УК-4',
                            cat:"Коммуникация",
                            desc:"Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {code: 'УК-5',
                            cat:"Межкультурное взаимодействие",
                            desc:"Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {code: 'УК-6',
                            cat:"Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc:"Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {code: 'УК-7',
                            cat:"Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc:"Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {code: 'УК-8',
                            cat:"Безопасность жизнедеятельности",
                            desc:"Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {code: 'УК-9',
                            cat:"Экономическая культура, в том числе финансовая грамотность",
                            desc:"Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {code: 'УК-10',
                            cat:"Гражданская позиция",
                            desc:"Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],

                    OPK:[{code:'ОПК-1',
                        cat:"Информационная культура",
                        desc:"Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                    },
                        {code:'ОПК-2',
                            cat:"Информационная культура",
                            desc:"Способен разрабатывать алгоритмы и компьютерные программы, пригодные для практического применения"
                        },
                        {code:'ОПК-3',
                            cat:"Фундаментальная подготовка",
                            desc:"Способен применять соответствующий физико-математический аппарат, методы анализа и моделирования, теоретического и экспериментального исследования при решении профессиональных задач"
                        },
                        {code:'ОПК-4',
                            cat:"Теоретическая профессиональная подготовка",
                            desc:"Способен демонстрировать применение основных способов получения, преобразования, транспорта и использования теплоты в теплотехнических установках и системах"
                        },
                        {code:'ОПК-5',
                            cat:"Практическая профессиональная подготовка",
                            desc:"Способен учитывать свойства конструкционных материалов в теплотехнических расчетах с учетом динамических и тепловых нагрузок"
                        },
                        {code: 'ОПК-6',
                            cat: "Практическая профессиональная подготовка",
                            desc: "Способен проводить измерения электрических и неэлектрических величин на объектах теплоэнергетики и теплотехники"
                        }]
                },
                '13.03.02': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-10',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Информационная культура",
                        desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Информационная культура",
                            desc: "Способен разрабатывать алгоритмы и компьютерные программы, пригодные для практического применения"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Фундаментальная подготовка",
                            desc: "Способен применять соответствующий физико-математический аппарат, методы анализа и моделирования, теоретического и экспериментального исследования при решении профессиональных задач"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Теоретическая и практическая профессиональная подготовка",
                            desc: "Способен использовать методы анализа и моделирования электрических цепей и электрических машин"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Теоретическая и практическая профессиональная подготовка",
                            desc: "Способен использовать свойства конструкционных и электротехнических материалов в расчетах параметров и режимов объектов профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Теоретическая и практическая профессиональная подготовка",
                            desc: "Способен проводить измерения электрических и неэлектрических величин применительно к объектам профессиональной деятельности"
                        }]
                },
                '29.03.05': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-10',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Аналитическое мышление",
                        desc: "Способен применять естественнонаучные и общеинженерные знания, методы математического анализа и моделирования в профессиональной деятельности"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Предпроектные исследования",
                            desc: "Способен участвовать в маркетинговых исследованиях, проводить сравнительную оценку изделий легкой промышленности"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Измерение параметров",
                            desc: "Способен проводить измерения параметров материалов и изделий легкой промышленности, обрабатывать полученные данные и представлять аналитический отчет"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Информационные технологии",
                            desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Проектирование и изготовление",
                            desc: "Способен использовать промышленные методы конструирования и автоматизированные системы проектирования при разработке изделий легкой промышленности"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Проектирование и изготовление",
                            desc: "Способен выбирать эффективные технические средства, оборудование и методы при изготовлении образцов изделий легкой промышленности"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Конструкторско-технологическая документация",
                            desc: "Способен разрабатывать и использовать конструкторско-технологическую документацию в процессе проектирования и производства изделий легкой промышленности"
                        },
                        {
                            code: 'ОПК-8',
                            cat: "Оценка качества",
                            desc: "Способен проводить оценку качества материалов и изделий легкой промышленности в соответствии с предъявляемыми требованиями"
                        }]
                },
                '39.03.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-10',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Информационно-коммуникационная грамотность при решении профессиональных задач",
                        desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Анализ социальных явлений и процессов",
                            desc: "Способен к социологическому анализу и научному объяснению социальных явлений и процессов на основе научных теорий, концепций, подходов"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Организация и проведение социологических исследований",
                            desc: "Способен принимать участие в социологическом исследовании на всех этапах его проведения"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Выявление и решение социально-значимых проблем",
                            desc: "Способен выявлять социально значимые проблемы и определять пути их решения на основе теоретических знаний и результатов социологических исследований"
                        }]
                },
                '39.03.02': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-10',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Информационно-коммуникационная грамотность при решении профессиональных задач",
                        desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Анализ и оценка профессиональной информации",
                            desc: "Способен описывать социальные явления и процессы на основе анализа и обобщения профессиональной информации, научных теорий, концепций и актуальных подходов"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Представление результатов профессиональной деятельности",
                            desc: "Способен составлять и оформлять отчеты по результатам профессиональной деятельности в сфере социальной работы"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Разработка и реализация профессионального инструментария",
                            desc: "Способен к использованию, контролю и оценке методов и приемов осуществления профессиональной деятельности в сфере социальной работы"
                        }]
                },
                '41.03.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-10',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Профессиональная коммуникация на государственном языке Российской Федерации и иностранном(ых) языке(ах)",
                        desc: "Способен осуществлять эффективную коммуникацию в мультикультурной профессиональной среде на государственном языке Российской Федерации и иностранном(ых) языке(ах) на основе применения понятийного аппарата по профилю деятельности"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Применение информационно-коммуникационных технологий",
                            desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Информационно-аналитическая деятельность",
                            desc: "Способен выделять, систематизировать и интерпретировать содержательно значимые эмпирические данные из потоков информации, а также смысловые конструкции в оригинальных текстах и источниках по профилю деятельности"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Экспертная оценка",
                            desc: "Способен устанавливать причинно-следственные связи, давать характеристику и оценку общественно-политическим и социально-экономическим событиям и процессам, выявляя их связь с экономическим, социальным и культурно-цивилизационным контекстами, а также с объективными тенденциями и закономерностями комплексного развития на глобальном макрорегиональном, национально-государственном, региональном и локальном уровнях"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Публицистическая деятельность",
                            desc: "Способен формировать дайджесты и аналитические материалы общественно-политической направленности по профилю деятельности для публикации в научных журналах и средствах массовой информации"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Организационно-управленческая деятельность",
                            desc: "Способен участвовать в организационно-управленческой деятельности и исполнять управленческие решения по профилю деятельности"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Представление результатов профессиональной деятельности",
                            desc: "Способен составлять и оформлять документы и отчеты по результатам профессиональной деятельности"
                        }]
                },
                '42.03.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-10',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Продукт профессиональной деятельности",
                        desc: "Способен создавать востребованные обществом и индустрией медиатексты и (или) медиапродукты, и (или) коммуникационные продукты в соответствии с нормами русского и иностранного языков, особенностями иных знаковых систем"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Общество и государство",
                            desc: "Способен учитывать тенденции развития общественных и государственных институтов для их разностороннего освещения в создаваемых медиатекстах и (или) медиапродуктах, и (или) коммуникационных продуктах"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Культура",
                            desc: "Способен использовать многообразие достижений отечественной и мировой культуры в процессе создания медиатекстов и (или) медиапродуктов, и (или) коммуникационных продуктов"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Аудитория",
                            desc: "Способен отвечать на запросы и потребности общества и аудитории в профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Медиакоммуникационна я система",
                            desc: "Способен учитывать в профессиональной деятельности тенденции развития медиакоммуникационных систем региона, страны и мира, исходя из политических и экономических механизмов их функционирования, правовых и этических норм регулирования"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Технологии",
                            desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Эффекты",
                            desc: "Способен учитывать эффекты и последствия своей профессиональной деятельности, следуя принципам социальной ответственности"
                        }]
                },
                '42.03.02': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-10',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Продукт профессиональной деятельности",
                        desc: "Способен создавать востребованные обществом и индустрией медиатексты и (или) медиапродукты, и (или) коммуникационные продукты в соответствии с нормами русского и иностранного языков, особенностями иных знаковых систем"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Общество и государство",
                            desc: "Способен учитывать тенденции развития общественных и государственных институтов для их разностороннего освещения в создаваемых медиатекстах и (или) медиапродуктах, и (или) коммуникационных продуктах"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Культура",
                            desc: "Способен использовать многообразие достижений отечественной и мировой культуры в процессе создания медиатекстов и (или) медиапродуктов, и (или) коммуникационных продуктов"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Аудитория",
                            desc: "Способен отвечать на запросы и потребности общества и аудитории в профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Медиакоммуникационна я система",
                            desc: "Способен учитывать в профессиональной деятельности тенденции развития медиакоммуникационных систем региона, страны и мира, исходя из политических и экономических механизмов их функционирования, правовых и этических норм регулирования"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Технологии",
                            desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Эффекты",
                            desc: "Способен учитывать эффекты и последствия своей профессиональной деятельности, следуя принципам социальной ответственности"
                        }]
                },
                '43.03.02': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-10',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Технологии",
                        desc: "Способен применять технологические новации и современное программное обеспечение в туристской сфере"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Управление",
                            desc: "Способен осуществлять основные функции управления туристской деятельностью"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Качество",
                            desc: "Способен обеспечивать требуемое качество процессов оказания услуг в избранной сфере профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Маркетинг",
                            desc: "Способен осуществлять исследование туристского рынка, организовывать продажи и продвижение туристского продукта"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Экономика",
                            desc: "Способен принимать экономически обоснованные решения, обеспечивать экономическую эффективность организаций избранной сферы профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Право",
                            desc: "Способен применять законодательство Российской Федерации, а также нормы международного права при осуществлении профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Безопасность обслуживания",
                            desc: "Способен обеспечивать безопасность обслуживания потребителей и соблюдение требований заинтересованных сторон на основании выполнения норм и правил охраны труда и техники безопасности"
                        },
                        {
                            code: 'ОПК-8',
                            cat: "Информационно-коммуникационные технологии для профессиональной деятельности",
                            desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                        }]
                },
                '43.03.03': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-10',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Технологии",
                        desc: "Способен применять технологические новации и современное программное обеспечение в сфере гостеприимства и общественного питания"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Управление",
                            desc: "Способен обеспечивать выполнение основных функций управления подразделениями организаций сферы гостеприимства и общественного питания"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Качество",
                            desc: "Способен обеспечивать требуемое качество процессов оказания услуг в избранной сфере профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Маркетинг",
                            desc: "Способен осуществлять исследование рынка, организовывать продажи и продвижение услуг организаций сферы гостеприимства и общественного питания"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Экономика",
                            desc: "Способен принимать экономически обоснованные решения, обеспечивать экономическую эффективность организаций избранной сферы профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Право",
                            desc: "Способен применять законодательство Российской Федерации, а также нормы международного права при осуществлении профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Безопасность обслуживания",
                            desc: "Способен обеспечивать безопасность обслуживания потребителей и соблюдение требований заинтересованных сторон на основании выполнения норм и правил охраны труда и техники безопасности"
                        },
                        {
                            code: 'ОПК-8',
                            cat: "Информационно-коммуникационные технологии для профессиональной деятельности",
                            desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                        }]
                },
                '44.03.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-10',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Правовые и этические основы профессиональной деятельности",
                        desc: "Способен осуществлять профессиональную деятельность в соответствии с нормативными правовыми актами в сфере образования и нормами профессиональной этики"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Разработка основных и дополнительных образовательных программ",
                            desc: "Способен участвовать в разработке основных и дополнительных образовательных программ, разрабатывать отдельные их компоненты (в том числе с использованием информационно-коммуникационных технологий)"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Совместная и индивидуальная учебная и воспитательная деятельность обучающихся",
                            desc: "Способен организовывать совместную и индивидуальную учебную и воспитательную деятельность обучающихся, в том числе с особыми образовательными потребностями, в соответствии с требованиями федеральных государственных образовательных стандартов"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Построение воспитывающей образовательной среды",
                            desc: "Способен осуществлять духовно-нравственное воспитание обучающихся на основе базовых национальных ценностей"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Контроль и оценка формирования результатов образования",
                            desc: "Способен осуществлять контроль и оценку формирования результатов образования обучающихся, выявлять и корректировать трудности в обучении"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Психолого-педагогические технологии в профессиональной деятельности",
                            desc: "Способен использовать психолого-педагогические технологии в профессиональной деятельности, необходимые для индивидуализации обучения, развития, воспитания, в том числе обучающихся с особыми образовательными потребностями"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Взаимодействие с участниками образовательных отношений",
                            desc: "Способен взаимодействовать с участниками образовательных отношений в рамках реализации образовательных программ"
                        },
                        {
                            code: 'ОПК-8',
                            cat: "Научные основы педагогической деятельности",
                            desc: "Способен осуществлять педагогическую деятельность на основе специальных научных знаний"
                        },
                        {
                            code: 'ОПК-9',
                            cat: "Информационно-коммуникационные технологии для профессиональной деятельности",
                            desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                        }]
                },
                '44.03.02': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-10',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Правовые и этические основы профессиональной деятельности",
                        desc: "Способен осуществлять профессиональную деятельность в соответствии с нормативными правовыми актами в сфере образования и нормами профессиональной этики"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Разработка основных и дополнительных образовательных программ",
                            desc: "Способен участвовать в разработке основных и дополнительных образовательных программ, разрабатывать отдельные их компоненты (в том числе с использованием информационно-коммуникационных технологий)"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Совместная и индивидуальная учебная и воспитательная деятельность обучающихся",
                            desc: "Способен организовывать совместную и индивидуальную учебную и воспитательную деятельность обучающихся, в том числе с особыми образовательными потребностями, в соответствии с требованиями федеральных государственных образовательных стандартов"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Построение воспитывающей образовательной среды",
                            desc: "Способен осуществлять духовно-нравственное воспитание обучающихся на основе базовых национальных ценностей"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Контроль и оценка формирования результатов образования",
                            desc: "Способен осуществлять контроль и оценку формирования результатов образования обучающихся, выявлять и корректировать трудности в обучении"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Психолого-педагогические технологии в профессиональной деятельности",
                            desc: "Способен использовать психолого-педагогические технологии в профессиональной деятельности, необходимые для индивидуализации обучения, развития, воспитания, в том числе обучающихся с особыми образовательными потребностями"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Взаимодействие с участниками образовательных отношений",
                            desc: "Способен взаимодействовать с участниками образовательных отношений в рамках реализации образовательных программ"
                        },
                        {
                            code: 'ОПК-8',
                            cat: "Научные основы педагогической деятельности",
                            desc: "Способен осуществлять педагогическую деятельность на основе специальных научных знаний"
                        },
                        {
                            code: 'ОПК-9',
                            cat: "Информационно-коммуникационные технологии для профессиональной деятельности",
                            desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                        }]
                },
                '44.03.05': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-10',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Правовые и этические основы профессиональной деятельности",
                        desc: "Способен осуществлять профессиональную деятельность в соответствии с нормативными правовыми актами в сфере образования и нормами профессиональной этики"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Разработка основных и дополнительных образовательных программ",
                            desc: "Способен участвовать в разработке основных и дополнительных образовательных программ, разрабатывать отдельные их компоненты (в том числе с использованием информационно-коммуникационных технологий)"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Совместная и индивидуальная учебная и воспитательная деятельность обучающихся",
                            desc: "Способен организовывать совместную и индивидуальную учебную и воспитательную деятельность обучающихся, в том числе с особыми образовательными потребностями, в соответствии с требованиями федеральных государственных образовательных стандартов"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Построение воспитывающей образовательной среды",
                            desc: "Способен осуществлять духовно-нравственное воспитание обучающихся на основе базовых национальных ценностей"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Контроль и оценка формирования результатов образования",
                            desc: "Способен осуществлять контроль и оценку формирования результатов образования обучающихся, выявлять и корректировать трудности в обучении"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Психолого-педагогические технологии в профессиональной деятельности",
                            desc: "Способен использовать психолого-педагогические технологии в профессиональной деятельности, необходимые для индивидуализации обучения, развития, воспитания, в том числе обучающихся с особыми образовательными потребностями"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Взаимодействие с участниками образовательных отношений",
                            desc: "Способен взаимодействовать с участниками образовательных отношений в рамках реализации образовательных программ"
                        },
                        {
                            code: 'ОПК-8',
                            cat: "Научные основы педагогической деятельности",
                            desc: "Способен осуществлять педагогическую деятельность на основе специальных научных знаний"
                        },
                        {
                            code: 'ОПК-9',
                            cat: "Информационно-коммуникационные технологии для профессиональной деятельности",
                            desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                        }]
                },
                '09.03.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-10',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: []
                },
                '09.03.02': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-10',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к коррупционному поведению"
                        }],
                    OPK: []
                },
                '09.03.04': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-10',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: []
                },
                '24.03.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-10',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: []
                },
                '18.03.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Инклюзивная компетентность",
                            desc: "Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {
                            code: 'УК-10',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-11',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Естественно-научная подготовка",
                        desc: "Способен изучать, анализировать, использовать механизмы химических реакций, происходящих в технологических процессах и окружающем мире, основываясь на знаниях о строении вещества, природе химической связи и свойствах различных классов химических элементов, соединений, веществ и материалов"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Профессиональная методология",
                            desc: "Способен использовать математические, физические, физико-химические, химические методы для решения задач профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Адаптация к производственным условиям",
                            desc: "Способен осуществлять профессиональную деятельность с учетом законодательства Российской Федерации, в том числе в области экономики и экологии"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Инженерная и технологическая подготовка",
                            desc: "Способен обеспечивать проведение технологического процесса, использовать технические средства для контроля параметров технологического процесса, свойств сырья и готовой продукции, осуществлять изменение параметров технологического процесса при изменении свойств сырья"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Научные исследования и разработки",
                            desc: "Способен осуществлять экспериментальные исследования и испытания по заданной методике, проводить наблюдения и измерения с учетом требований техники безопасности, обрабатывать и интерпретировать экспериментальные данные"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Информационно-коммуникационные технологии для профессиональной деятельности",
                            desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                        }]
                },
                '18.04.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Научные исследования и разработки",
                        desc: "Способен организовывать самостоятельную и коллективную научно-исследовательскую работу, разрабатывать планы и программы проведения научных исследований и технических разработок"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Профессиональная методология",
                            desc: "Способен использовать современные приборы и методики, организовывать проведение экспериментов и испытаний, проводить их обработку и анализировать их результаты "
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Инженерная и технологическая подготовка",
                            desc: "Способен разрабатывать нормы выработки, технологические нормативы на расход материалов, заготовок, топлива и электроэнергии, контролировать параметры технологического процесса, выбирать оборудование и технологическую оснастку"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Производственная деятельность",
                            desc: "Способен находить оптимальные решения при создании продукции с учетом требований качества, надежности и стоимости, а также сроков исполнения, безопасности жизнедеятельности и экологической чистоты"
                        }]
                },
                '20.04.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы её совершенствование на основе самооценки"
                        }],
                    OPK: []
                },
                '37.03.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Инклюзивная компетентность",
                            desc: "Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {
                            code: 'УК-10',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-11',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Научное исследование и оценка",
                        desc: "Способен осуществлять научное исследование в сфере профессиональной деятельности на основе современной методологии"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Научное исследование и оценка",
                            desc: "Способен применять методы сбора, анализа и интерпретации эмпирических данных в соответствии с поставленной задачей, оценивать достоверность эмпирических данных и обоснованность выводов научных исследований"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Психологическая диагностика",
                            desc: "Способен выбирать адекватные, надежные и валидные методы количественной и качественной психологической оценки, организовывать сбор данных для решения задач психодиагностики в заданной области исследований и практики"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Психологическое вмешательство (развитие, коррекция, реабилитация)",
                            desc: "Способен использовать основные формы психологической помощи для решения конкретной проблемы отдельных лиц, групп населения и (или) организаций, в том числе лицам с ограниченными возможностями здоровья и при организации инклюзивного образования "
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Психологическое вмешательство (развитие, коррекция, реабилитация)",
                            desc: "Способен выполнять организационную и техническую работу в реализации конкретных мероприятий профилактического, развивающего, коррекционного или реабилитационного характера"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Психологическая профилактика",
                            desc: "Способен оценивать и удовлетворять потребности и запросы целевой аудитории для стимулирования интереса к психологическим знаниям, практике и услугам"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Супервизия",
                            desc: "Способен поддерживать уровень профессиональной компетенции, в том числе за счет понимания и готовности работать под супервизией"
                        },
                        {
                            code: 'ОПК-8',
                            cat: "Администрирование (организация и управление)",
                            desc: "Способен выполнять свои профессиональные функции в организациях разного типа, осознанно соблюдая организационные политики и процедуры"
                        },
                        {
                            code: 'ОПК-9',
                            cat: "Информационно-коммуникационные технологии для профессиональной деятельности",
                            desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                        }]
                },
                '40.03.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Инклюзивная компетентность",
                            desc: "Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {
                            code: 'УК-10',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-11',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Юридический анализ",
                        desc: "Способен анализировать основные закономерности формирования, функционирования и развития права"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Решение юридических проблем",
                            desc: "Способен применять нормы материального и процессуального права при решении задач профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Юридическая экспертиза",
                            desc: "Способен участвовать в экспертной юридической деятельности в рамках поставленной задачи"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Толкование права",
                            desc: "Способен профессионально толковать нормы права"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Юридическая аргументация",
                            desc: "Способен логически верно, аргументированно и ясно строить устную и письменную речь с единообразным и корректным использованием профессиональной юридической лексики"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Юридическое письмо",
                            desc: "Способен участвовать в подготовке проектов нормативных правовых актов и иных юридических документов"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Профессиональная этика",
                            desc: "Способен соблюдать принципы этики юриста, в том числе в части антикоррупционных стандартов поведения"
                        },
                        {
                            code: 'ОПК-8',
                            cat: "Информационные технологии",
                            desc: "Способен целенаправленно и эффективно получать юридически значимую информацию из различных источников, включая правовые базы данных, решать задачи профессиональной деятельности с применением информационных технологий и с учетом требований информационной безопасности"
                        },
                        {
                            code: 'ОПК-9',
                            cat: "Информационные технологии",
                            desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                        }]
                },
                '47.03.03': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Инклюзивная компетентность",
                            desc: "Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {
                            code: 'УК-10',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-11',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Методологические и педагогические компетенции",
                        desc: "Способен владеть навыками логического анализа различного рода рассуждений и профессиональной аргументации в области религиоведения "
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Методологические и педагогические компетенции",
                            desc: "Способен использовать концепции и методы философии религии, социологии религии, истории религии, психологии религии в практической деятельности "
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Методологические и педагогические компетенции",
                            desc: "Способен самостоятельно собирать и обрабатывать научную информацию в области религиоведения и религиоведческих дисциплин (модулей)"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Организаторские и аналитические компетенции",
                            desc: "Способен решать стандартные задачи профессиональной деятельности на основе информационной и библиографической культуры с применением информационно-коммуникационных технологий и с учетом основных требований информационной безопасности"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Информационно-коммуникационные технологии для профессиональной деятельности",
                            desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                        }]
                },
                '54.03.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятель"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Инклюзивная компетентность",
                            desc: "Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {
                            code: 'УК-10',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-11',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Профессиональная ориентация",
                        desc: "Способен применять знания в области истории и теории искусств, истории и теории дизайна в профессиональной деятельности; рассматривать произведения искусства, дизайна и техники в широком культурно-историческом контексте в тесной связи с религиозными, философскими и эстетическими идеями конкретного исторического периода"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Научные исследования",
                            desc: "Способен работать с научной литературой; собирать, анализировать и обобщать результаты научных исследований; оценивать полученную информацию; самостоятельно проводить научно-исследовательскую работу; участвовать в научно-практических конференциях"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Методы творческого процесса дизайнеров",
                            desc: "Способен выполнять поисковые эскизы изобразительными средствами и способами проектной графики; разрабатывать проектную идею, основанную на концептуальном, творческом подходе к решению дизайнерской задачи; синтезировать набор возможных решений и научно обосновывать свои предложения при проектировании дизайн-объектов, удовлетворяющих утилитарные и эстетические потребности человека (техника и оборудование, транспортные средства, интерьеры, полиграфия, товары народного потребления)"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Создание авторского дизайн-проекта",
                            desc: "Способен проектировать, моделировать, конструировать предметы, товары, промышленные образцы и коллекции, художественные предметно-пространственные комплексы, интерьеры зданий и сооружений архитектурно-пространственной среды, объекты ландшафтного дизайна, используя линейно-конструктивное построение, цветовое решение композиции, современную шрифтовую культуру и способы проектной графики"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Организаторская деятельность",
                            desc: "Способен организовывать, проводить и участвовать в выставках, конкурсах, фестивалях и других творческих мероприятиях"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Информационно-коммуникационные технологии",
                            desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Педагогическая деятельность",
                            desc: "Способен осуществлять педагогическую деятельность в сфере дошкольного, начального общего, основного общего, среднего общего образования, профессионального обучения и дополнительного образования"
                        },
                        {
                            code: 'ОПК-8',
                            cat: "Государственная культурная политика",
                            desc: "Способен ориентироваться в проблематике современной культурной политики Российской Федерации"
                        }]
                },
                '21.05.02': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Инклюзивная компетентность",
                            desc: "Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {
                            code: 'УК-10',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-11',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Применение фундаментальных знаний",
                        desc: "Способен применять правовые основы геологического изучения недр и недропользования, обеспечения экологической и промышленной безопасности и уметь их учитывать при поисках, разведке и эксплуатации месторождений полезных ископаемых, а также строительстве"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Применение фундаментальных знаний",
                            desc: "Способен применять методы и способы геолого-экономической оценки минерально-сырьевой базы и месторождений полезных ископаемых"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Применение фундаментальных знаний",
                            desc: "Способен применять основные положения фундаментальных естественных наук и научных теорий при проведении научно-исследовательских работ по изучению и воспроизводству минерально-сырьевой базы"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Применение фундаментальных знаний",
                            desc: "Способен применять методы обеспечения безопасности жизнедеятельности, в том числе в условиях чрезвычайных ситуаций, при производстве работ по геологическому изучению недр, поискам, разведке, добыче и переработке полезных ископаемых, промышленно-гражданскому строительству"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Техническое проектирование",
                            desc: "Способен применять навыки анализа горно-геологических условий при поисках, оценке, разведке и добыче полезных ископаемых, а также при гражданском строительстве"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Техническое проектирование",
                            desc: "Способен работать с программным обеспечением общего, специального назначения, в том числе моделировать горные и геологические объекты"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Техническое проектирование",
                            desc: "Способен осуществлять техническое руководство горными и взрывными работами при поисках, разведке и разработке месторождений полезных ископаемых, гражданском строительстве, в том числе в условиях чрезвычайных ситуаций"
                        },
                        {
                            code: 'ОПК-8',
                            cat: "Техническое проектирование",
                            desc: "Способен применять основные методы, способы и средства получения, хранения и обработки информации, используя навыки работы с компьютером как средством управления информацией"
                        },
                        {
                            code: 'ОПК-9',
                            cat: "Техническое проектирование",
                            desc: "Способен ориентироваться на местности, определять пространственное положение объектов, осуществлять необходимые геодезические и маркшейдерские измерения, обрабатывать и интерпретировать их результаты"
                        },
                        {
                            code: 'ОПК-10',
                            cat: "Техническое проектирование",
                            desc: "Способен планировать, проектировать, организовывать геологоразведочные и горные работы, вести учет и контроль выполняемых работ, анализировать оперативные и текущие показатели производства, обосновывать предложения по совершенствованию организации производства, оперативно устранять нарушения производственных процессов"
                        },
                        {
                            code: 'ОПК-11',
                            cat: "Техническое проектирование",
                            desc: "Способен в составе творческих коллективов и самостоятельно, контролировать соответствие проектов требованиям стандартов, техническим условиям и документам промышленной безопасности, разрабатывать, согласовывать и утверждать в установленном порядке технические и методические документы, регламентирующие порядок, качество и безопасность выполнения поисковых, геологоразведочных, горных и взрывных работ"
                        },
                        {
                            code: 'ОПК-12',
                            cat: "Исследование",
                            desc: "Способен проводить самостоятельно или в составе группы научный поиск, реализуя специальные средства и методы получения нового знания, участвовать в научных исследованиях объектов профессиональной деятельности и их структурных элементов "
                        },
                        {
                            code: 'ОПК-13',
                            cat: "Исследование",
                            desc: "Способен изучать и анализировать вещественный состав горных пород и руд и геологопромышленные и генетические типы месторождений полезных ископаемых при решении задач по рациональному и комплексному освоению минерально-сырьевой базы "
                        },
                        {
                            code: 'ОПК-14',
                            cat: "Исследование",
                            desc: "Способен выполнять маркетинговые исследования, проводить экономический анализ затрат для реализации процессов геологоразведочного производства в целом"
                        },
                        {
                            code: 'ОПК-15',
                            cat: "Интеграция науки и образования",
                            desc: "Способен участвовать в разработке и реализации образовательных программ в сфере своей профессиональной деятельности, используя профессиональные знания"
                        },
                        {
                            code: 'ОПК-16',
                            cat: "Информационно-коммуникационные технологии для профессиональной деятельности",
                            desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                        }]
                },
                '54.05.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки и образования в течение всей жизни"
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Инклюзивная компетентность",
                            desc: "Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {
                            code: 'УК-10',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-11',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Профессиональная ориентация",
                        desc: "Способен понимать сущность и социальную значимость своей профессиональной деятельности в сфере науки, культуры и искусства; основные проблемы дисциплин (модулей), определяющих конкретную область его деятельности, их взаимосвязь в целостной системе знаний"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Организаторская деятельность",
                            desc: "Способен организовывать и проводить выставки, конкурсы, фестивали, презентации, инсталляции; осуществлять подбор необходимой научно-методической, искусствоведческой литературы; выдвигать и разрабатывать концептуальные, экспериментальные и инновационные идеи; участвовать в творческих мероприятиях (художественных выставках, конкурсах)"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Самообучение и самоорганизация",
                            desc: "Способен проявлять навыки социального взаимодействия, самоорганизации и самоуправления системно-деятельностного характера; к активному общению в творческой, научной, производственной и художественной жизни; самостоятельно обучаться новым методам исследований; участвовать в творческих мероприятиях (художественных выставках, конкурсах, фестивалях)"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Исследовательские и проектные работы",
                            desc: "Способен использовать знания, умения и навыки в проведении научно-исследовательских и проектных работ; собирать, обрабатывать, анализировать интерпретировать информацию из различных источников с использованием современных средств и технологий; участвовать в научно-практических конференциях; делать доклады и сообщения; защищать авторский художественный проект с использованием современных средств и технологий"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Информационно-коммуникационные технологии",
                            desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Руководство коллективом",
                            desc: "Способен руководить коллективом в сфере своей профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Правовые и экономические основы профессиональной деятельности",
                            desc: "Способен использовать знания в области авторского права и экономических основ творческой деятельности"
                        },
                        {
                            code: 'ОПК-8',
                            cat: "Государственная культурная политика",
                            desc: "Способен ориентироваться в проблематике современной культурной политики Российской Федерации"
                        },
                        {
                            code: 'ОПК-9',
                            cat: "Педагогическая деятельность",
                            desc: "Способен осуществлять педагогическую деятельность по программам дошкольного, начального общего, основного общего образования, профессионального обучения, профессионального образования и дополнительного образования"
                        }]
                },
                '03.03.02': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Инклюзивная компетентность",
                            desc: "Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {
                            code: 'УК-10',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-11',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: []
                },
                '15.03.04': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Инклюзивная компетентность",
                            desc: "Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {
                            code: 'УК-10',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-11',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: []
                },
                '20.03.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Инклюзивная компетентность",
                            desc: "Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {
                            code: 'УК-10',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-11',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: []
                },
                '38.03.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Инклюзивная компетентность",
                            desc: "Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {
                            code: 'УК-10',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-11',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: []
                },
                '38.03.02': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Инклюзивная компетентность",
                            desc: "Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {
                            code: 'УК-10',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-11',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: []
                },
                '38.03.04': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Инклюзивная компетентность",
                            desc: "Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {
                            code: 'УК-10',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-11',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: []
                },
                '45.03.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Инклюзивная компетентность",
                            desc: "Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {
                            code: 'УК-10',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-11',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: []
                },
                '45.03.02': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни  "
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Инклюзивная компетентность",
                            desc: "Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {
                            code: 'УК-10',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-11',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: []
                },
                '58.03.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен воспринимать межкультурное разнообразие общества в социально- историческом, этическом и философском контекстах"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни"
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Инклюзивная компетентность",
                            desc: "Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {
                            code: 'УК-10',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-11',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: [
                        {
                            code: 'ОПК-1',
                            cat: "Профессиональная коммуникация на иностранных языках",
                            desc: "Способен осуществлять коммуникацию на языке народов Азии и Африки (помимо освоения различных аспектов современного языка предполагается знакомство с классическим (древним) вариантом данного языка)"
                        },
                        {
                            code: 'ОПК-2',
                            cat: "Представление результатов профессиональной деятельности",
                            desc: "Способен представлять результаты профессиональной деятельности с применением понятийного аппарата, общенаучной и профессиональной терминологии в сфере изучения стран Азии и Африки"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Применение информационно-коммуникационных технологий",
                            desc: "Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Системное мышление в аналитической и научной деятельности",
                            desc: "Способен осуществлять анализ профессиональной информации, в том числе выделять содержательно значимые данные из потоков информации в профессиональной сфере и систематизировать их согласно поставленным задачам"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Научно-исследовательская деятельность",
                            desc: "Способен использовать знания основных географических, демографических, экономических и социально-политических характеристик изучаемой страны (региона) при ведении научных исследований"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Информационно-аналитическая деятельность",
                            desc: "Способность собирать и обрабатывать материал по основным группам востоковедных исследований и использовать полученные результаты в практической работе"
                        }]
                },
                '24.05.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки и образования в течение всей жизни"
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Инклюзивная компетентность",
                            desc: "Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {
                            code: 'УК-10',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-11',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: []
                },
                '38.05.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла."
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели."
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки и образования в течение всей жизни"
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Инклюзивная компетентность",
                            desc: "Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {
                            code: 'УК-10',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-11',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: []
                },
                '38.05.02': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки и образования в течение всей жизни"
                        },
                        {
                            code: 'УК-7',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {
                            code: 'УК-8',
                            cat: "Безопасность жизнедеятельности",
                            desc: "Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {
                            code: 'УК-9',
                            cat: "Экономическая культура, в том числе финансовая грамотность",
                            desc: "Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {
                            code: 'УК-10',
                            cat: "Гражданская позиция",
                            desc: "Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],
                    OPK: []
                },
                '01.04.02': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Теоретические и практические основы профессиональной деятельности",
                        desc: "Способен решать актуальные задачи фундаментальной и прикладной математики "
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Теоретические и практические основы профессиональной деятельности",
                            desc: "Способен совершенствовать и реализовывать новые математические методы решения прикладных задач "
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Теоретические и практические основы профессиональной деятельности",
                            desc: "Способен разрабатывать математические модели и проводить их анализ при решении задач в области профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Информационно-коммуникационные технологии для профессиональной деятельности",
                            desc: "Способен комбинировать и адаптировать существующие информационно-коммуникационные технологии для решения задач в области профессиональной деятельности с учетом требований информационной безопасности"
                        }]
                },
                '13.04.02': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Планирование",
                        desc: "Способен формулировать цели и задачи исследования, выявлять приоритеты решения задач, выбирать критерии оценки"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Исследование",
                            desc: "Способен применять современные методы исследования, оценивать и представлять результаты выполненной работы."
                        }]
                },
                '37.04.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Научное исследование и оценка",
                        desc: "Способен организовывать научное исследование в сфере профессиональной деятельности на основе современной методологии"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Научное исследование и оценка",
                            desc: "Способен планировать, разрабатывать и реализовывать программы научного исследования для решения теоретических и практических задач в сфере профессиональной деятельности, применять обоснованные методы оценки исследовательских и прикладных программ"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Психологическая диагностика и экспертиза",
                            desc: "Способен использовать научно обоснованные подходы и валидные способы количественной и качественной диагностики и оценки для решения научных, прикладных и экспертных задач."
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Психологическая диагностика и экспертиза",
                            desc: "Способен проводить оценку психометрических характеристик используемых психодиагностических инструментов, составлять протоколы, заключения, отчеты по результатам психологической оценки, диагностики экспертизы, а также представлять обратную связь по ним"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Психологическое вмешательство (развитие, коррекция, реабилитация)",
                            desc: "Способен разрабатывать и реализовывать научно обоснованные программы вмешательства профилактического, развивающего, коррекционного или реабилитационного характера для решения конкретной психологической проблемы отдельных лиц, групп и (или) организаций"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Психологическое консультирование",
                            desc: "Способен разрабатывать и реализовывать комплексные программы предоставления психологических услуг по индивидуальному, семейному и групповому психологическому консультированию в соответствии с потребностями и целями клиента "
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Психологическая профилактика",
                            desc: "Способен вести просветительскую и психолого-профилактическую деятельность среди различных категорий населения с целью повышения психологической культуры общества и понимания роли психологии в решении социально- и индивидуально значимых задач в сфере охраны здоровья и смежных с ней областей"
                        },
                        {
                            code: 'ОПК-8',
                            cat: "Супервизия",
                            desc: "Способен использовать модели и методы супервизии для контроля и совершенствования профессиональной деятельности психолога"
                        },
                        {
                            code: 'ОПК-9',
                            cat: "Администрирование (организация и управление)",
                            desc: "Способен выполнять основные функции управления психологической практикой"
                        },
                        {
                            code: 'ОПК-10',
                            cat: "Преподавание (обучение)",
                            desc: "Способен осуществлять педагогическую деятельность на основе новейших разработок в области образования и психологической науки и практики применительно к образовательным потребностям представителей различных групп населения, в том числе особых социальных групп населения (групп риска, уязвимых категорий населения, лиц с ограниченными возможностями здоровья) и при организации инклюзивного образования  "
                        }]
                },
                '39.04.02': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Информационно-коммуникативная грамотность при решении профессиональных задач",
                        desc: "Способен применять современные информационно-коммуникативные технологии и программные средства при постановке и решении задач профессиональной деятельности в сфере социальной работы"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Анализ и оценка профессиональной информации",
                            desc: "Способен объяснять и прогнозировать социальные явления и процессы, выявлять социально значимые проблемы и вырабатывать пути их решения на основе анализа и оценки профессиональной информации, научных теорий и компетенций   "
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Представление результатов профессиональной деятельности",
                            desc: "Способен систематизировать и представлять результаты профессиональной деятельности в сфере социальной работы, в том числе в форме публичного выступления"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Разработка и реализация профессионального инструментария",
                            desc: "Способен к разработке, внедрению, контролю, оценке и корректировке методов и приемов осуществления профессиональной деятельности в сфере социальной работы "
                        }]
                },
                '40.04.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Юридический анализ",
                        desc: "Способен анализировать нестандартные ситуации правоприменительной практики и предлагать оптимальные варианты их решения"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Юридическая экспертиза",
                            desc: "Способен самостоятельно готовить экспертные юридические заключения и проводить экспертизу нормативных (индивидуальных) правовых актов"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Толкование права",
                            desc: "Способен квалифицированно толковать правовые акты, в том числе в ситуациях наличия пробелов и коллизий норм прав"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Юридическая аргументация",
                            desc: "Способен письменно и устно аргументировать правовую позицию по делу, в том числе в состязательных процессах"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Юридическое письмо",
                            desc: "Способен самостоятельно составлять юридические документы и разрабатывать проекты нормативных (индивидуальных) правовых актов"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Профессиональная этика",
                            desc: "Способен обеспечивать соблюдение принципов этики юриста, в том числе принимать меры по профилактике коррупции и пресечению коррупционных (иных) правонарушений"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Информационные технологии",
                            desc: "Способен применять информационные технологии и использовать правовые базы данных для решения задач профессиональной деятельности с учетом требований информационной безопасности"
                        }]
                },
                '41.04.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Профессиональная коммуникация на государственном языке Российской Федерации и иностранном(ых) языке(ах)",
                        desc: "Способен выстраивать профессиональную коммуникацию на государственном языке Российской Федерации и иностранном(ых) языке(ах) по профилю деятельности в мультикультурной среде на основе применения различных коммуникативных технологий с учетом специфики деловой и духовной культуры России и зарубежных стран"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Применение информационно-коммуникационных технологий",
                            desc: "Способен осуществлять поиск и применять перспективные информационно-коммуникационные технологии и программные средства для комплексной постановки и решения задач профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Экспертно-аналитическая деятельность",
                            desc: "Способен оценивать, моделировать и прогнозировать глобальные, макрорегиональные, национально-государственные, региональные и локальные политико-культурные, социально-экономические и общественно-политические процессы на основе применения методов теоретического и эмпирического исследования и прикладного анализа"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Научные исследования",
                            desc: "Способен проводить научные исследования по профилю деятельности, в том числе в междисциплинарных областях, самостоятельно формулировать научные гипотезы и инновационные идеи, проверять их достоверность"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Публицистическая деятельность",
                            desc: "Способен выстраивать стратегию по продвижению публикаций по профилю деятельности в средствах массовой информации на основе базовых принципов медиаменеджмента"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Организационно-управленческая деятельность",
                            desc: "Способен разрабатывать и реализовывать организационно-управленческие решения по профилю деятельности"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Представление результатов профессиональной деятельности",
                            desc: "Способен самостоятельно выстраивать стратегии представления результатов своей профессиональной деятельности, в том числе в публичном формате, на основе подбора соответствующих информационно-коммуникативных технологий и каналов распространения информации"
                        },
                        {
                            code: 'ОПК-8',
                            cat: "Прикладные исследования и консалтинг",
                            desc: "Способен разрабатывать предложения и рекомендации для проведения прикладных исследований и консалтинга"
                        },
                        {
                            code: 'ОПК-9',
                            cat: "Педагогическая деятельность",
                            desc: "Способен участвовать в реализации основных профессиональных и дополнительных образовательных программ"
                        }]

                },
                '42.04.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Продукт профессиональной деятельности",
                        desc: "Способен планировать, организовывать и координировать процесс создания востребованных обществом и индустрией медиатекстов и (или) медиапродуктов, и (или) коммуникационных продуктов, отслеживать и учитывать изменение норм русского и иностранного языков, особенностей иных знаковых систем"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Общество и государство",
                            desc: "Способен анализировать основные тенденции развития общественных и государственных институтов для их разностороннего освещения в создаваемых медиатекстах и (или) медиапродуктах, и (или) коммуникационных продуктах"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Культура",
                            desc: "Способен анализировать многообразие достижений отечественной и мировой культуры в процессе создания медиатекстов и (или) медиапродуктов, и (или) коммуникационных продуктов"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Аудитория",
                            desc: "Способен анализировать потребности общества и интересы аудитории в целях прогнозирования и удовлетворения спроса на медиатексты и (или) медиапродукты, и (или) коммуникационные продукты"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Медиакоммуникационная система",
                            desc: "Способен для принятия профессиональных решений анализировать актуальные тенденции развития медиакоммуникационных систем региона, страны и мира, исходя из политических и экономических механизмов их функционирования, правовых и этических норм регулирования"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Технологии",
                            desc: "Способен отбирать и внедрять в процесс медиапроизводства современные технические средства и информационно-коммуникационные технологии"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Эффекты",
                            desc: "Способен оценивать и прогнозировать возможные эффекты в медиасфере, следуя принципам социальной ответственности"
                        }]
                },
                '43.04.02': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Технологии",
                        desc: "Способен формировать технологическую концепцию туристской организации, организовывать внедрение технологических новаций и программного обеспечения в сфере туризма"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Управление",
                            desc: "Способен осуществлять стратегическое управление туристской деятельностью на различных уровнях управления"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Качество",
                            desc: "Способен разрабатывать и внедрять системы управления качеством услуг в сфере туризма"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Маркетинг",
                            desc: "Способен разрабатывать и внедрять маркетинговые стратегии и программы в сфере туризма"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Экономика",
                            desc: "Способен обеспечивать обоснование, разработку и внедрение экономической стратегии предприятия, приоритетных направлений его деятельности и уметь оценивать эффективность управленческих решений"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Научно-прикладные исследования",
                            desc: "Способен планировать и применять подходы, методы и технологии научно-прикладных исследований в избранной сфере профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Педагогика",
                            desc: "Способен осуществлять педагогическую деятельность по основным профессиональным образовательным программам и дополнительным профессиональным программам"
                        }]
                },
                '44.04.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Правовые и этические основы профессиональной деятельности",
                        desc: "Способен осуществлять и оптимизировать профессиональную деятельность в соответствии с нормативными правовыми актами в сфере образования и нормами профессиональной этики"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Разработка основных и дополнительных образовательных программ",
                            desc: "Способен проектировать основные и дополнительные образовательные программы и разрабатывать научно-методическое обеспечение их реализации"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Совместная и индивидуальная учебная и воспитательная деятельность обучающихся",
                            desc: "Способен проектировать организацию совместной и индивидуальной учебной и воспитательной деятельности обучающихся, в том числе с особыми образовательными потребностями"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Построение воспитывающей образовательной среды",
                            desc: "Способен создавать и реализовывать условия и принципы духовно-нравственного воспитания обучающихся на основе базовых национальных ценностей"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Контроль и оценка формирования результатов образования",
                            desc: "Способен разрабатывать программы мониторинга результатов образования обучающихся, разрабатывать и реализовывать программы преодоления трудностей в обучении"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Психолого-педагогическ ие технологии в профессиональной деятельности",
                            desc: "Способен проектировать и использовать эффективные психолого-педагогические, в том числе инклюзивные, технологии в профессиональной деятельности, необходимые для индивидуализации обучения, развития, воспитания обучающихся с особыми образовательными потребностями"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Взаимодействие с участниками образовательных отношений",
                            desc: "Способен планировать и организовывать взаимодействия участников образовательных отношений"
                        },
                        {
                            code: 'ОПК-8',
                            cat: "Научные основы педагогической деятельности",
                            desc: "Способен проектировать педагогическую деятельность на основе специальных научных знаний и результатов исследований"
                        }]
                },
                '44.04.02': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Правовые и этические основы профессиональной деятельности",
                        desc: "Способен осуществлять и оптимизировать профессиональную деятельность в соответствии с нормативными правовыми актами в сфере образования и нормами профессиональной этики"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Разработка основных и дополнительных образовательных программ",
                            desc: "Способен проектировать основные и дополнительные образовательные программы и разрабатывать научно-методическое обеспечение их реализации"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Совместная и индивидуальная учебная и воспитательная деятельность обучающихся",
                            desc: "Способен проектировать организацию совместной и индивидуальной учебной и воспитательной деятельности обучающихся, в том числе с особыми образовательными потребностями"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Построение воспитывающей образовательной среды",
                            desc: "Способен создавать и реализовывать условия и принципы духовно-нравственного воспитания обучающихся на основе базовых национальных ценностей"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Контроль и оценка формирования результатов образования",
                            desc: "Способен разрабатывать программы мониторинга результатов образования обучающихся, разрабатывать и реализовывать программы преодоления трудностей в обучении"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Психолого-педагогическ ие технологии в профессиональной деятельности",
                            desc: "Способен проектировать и использовать эффективные психолого-педагогические, в том числе инклюзивные, технологии в профессиональной деятельности, необходимые для индивидуализации обучения, развития, воспитания обучающихся с особыми образовательными потребностями"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Взаимодействие с участниками образовательных отношений",
                            desc: "Способен планировать и организовывать взаимодействия участников образовательных отношений"
                        },
                        {
                            code: 'ОПК-8',
                            cat: "Научные основы педагогической деятельности",
                            desc: "Способен проектировать педагогическую деятельность на основе специальных научных знаний и результатов исследований"
                        }]
                },
                '45.04.03': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Фундаментальные основы профессиональной деятельности",
                        desc: "Способен решать профессиональные задачи, применяя основные понятия, категории и положения лингвистических теорий и актуальные концепции в области лингвистики"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Фундаментальные основы профессиональной деятельности",
                            desc: "Способен анализировать, сопоставлять и критически оценивать различные лингвистические направления, теории и гипотезы при решении задач профессиональной деятельности"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Фундаментальные основы профессиональной деятельности",
                            desc: "Способен выбирать оптимальные подходы и методы решения конкретных научных и прикладных задач в области лингвистики и информационных технологий"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Фундаментальные основы профессиональной деятельности",
                            desc: "Способен расширять сферу научной деятельности, участвовать в междисциплинарных исследованиях на стыке наук"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Экспертная оценка",
                            desc: "Способен проводить подготовку и лингвистическую экспертную оценку нормативных и технических документов в сфере своей профессиональной деятельности с опорой на нормы официально-делового, научно-популярного, публицистического стилей русского языка"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Информационно-коммуникационная культура",
                            desc: "Способен осуществлять эффективное управление разработкой программных средств и информационных проектов в сфере своей профессиональной деятельности"
                        }]
                },
                '47.04.03': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],
                    OPK: [{
                        code: 'ОПК-1',
                        cat: "Методологические и педагогические компетенции",
                        desc: "Способен использовать в практической деятельности понимание специфики современных религиоведческих проблем, места религиоведения в культуре нашего времени, основных тенденций ее развития, а также роли религиоведения в современных интеграционных процессах формирования единой культуры"
                    },
                        {
                            code: 'ОПК-2',
                            cat: "Методологические и педагогические компетенции",
                            desc: "Способен использовать в практической деятельности понимание специфики онтологического, гносеологического и аксиологического аспектов религиоведческого знания, владеть основными категориями феноменологии религии, религиозной философии и теологии, взаимоотношений религии и политики, свободы совести и государственно-конфессиональных отношений, эзотерических и мистических учений"
                        },
                        {
                            code: 'ОПК-3',
                            cat: "Методологические и педагогические компетенции",
                            desc: "Способен использовать в практической деятельности владение основными современными концепциями мирового и российского религиоведения, понимание концептуальных различий между различными школами и направлениями, понимание основного содержания религиоведческих дискуссий современности"
                        },
                        {
                            code: 'ОПК-4',
                            cat: "Методологические и педагогические компетенции",
                            desc: "Способен использовать в практической деятельности понимание специфических особенностей религиозной и религиозно-философской мысли Запада и Востока, религиозной и светской философии, владение герменевтикой священных текстов религий мира"
                        },
                        {
                            code: 'ОПК-5',
                            cat: "Методологические и педагогические компетенции",
                            desc: "Способен использовать в практической деятельности понимание основных этапов развития мирового и российского религиоведения"
                        },
                        {
                            code: 'ОПК-6',
                            cat: "Методологические и педагогические компетенции",
                            desc: "Способен использовать в практической деятельности понимание различных концепций человека, развиваемых в родоплеменных, народностно-национальных и мировых религиях, ориентироваться в основных парадигмах современной религиозной антропологии"
                        },
                        {
                            code: 'ОПК-7',
                            cat: "Методологические и педагогические компетенции",
                            desc: "Способен использовать в практической деятельности понимание специфики решения антропологических проблем в религиозной философии"
                        },
                        {
                            code: 'ОПК-8',
                            cat: "Организаторские и аналитические компетенции",
                            desc: "Способен самостоятельно анализировать религиоведческую, философскую, социально-политическую и научную литературу, на основании научного анализа тенденций социального, экономического и духовного развития общества делать прогнозы и выдавать рекомендации, осуществлять поиск информации через библиотечные фонды, компьютерные системы информационного обеспечения, периодическую печать"
                        }]
                },
                '03.04.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],
                    OPK: []
                },
                '09.04.04': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],
                    OPK: []
                },
                '38.04.04': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],
                    OPK: []
                },
                '45.04.01': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],
                    OPK: []
                },
                '45.04.02': {
                    UK: [{
                        code: 'УК-1',
                        cat: "Системное и критическое мышление",
                        desc: "Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {
                            code: 'УК-2',
                            cat: "Разработка и реализация проектов",
                            desc: "Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {
                            code: 'УК-3',
                            cat: "Командная работа и лидерство",
                            desc: "Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {
                            code: 'УК-4',
                            cat: "Коммуникация",
                            desc: "Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {
                            code: 'УК-5',
                            cat: "Межкультурное взаимодействие",
                            desc: "Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {
                            code: 'УК-6',
                            cat: "Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc: "Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки"
                        }],
                    OPK: []
                },
                '10.03.01':{
                    UK:[{code: 'УК-1',
                        cat:"Системное и критическое мышление",
                        desc:"Способен осуществлять поиск, критический анализ и синтез информации, применять системный подход для решения поставленных задач"
                    },
                        {code: 'УК-2',
                            cat:"Разработка и реализация проектов",
                            desc:"Способен определять круг задач в рамках поставленной цели и выбирать оптимальные способы их решения, исходя из действующих правовых норм, имеющихся ресурсов и ограничений"
                        },
                        {code: 'УК-3',
                            cat:"Командная работа и лидерство",
                            desc:"Способен осуществлять социальное взаимодействие и реализовывать свою роль в команде"
                        },
                        {code: 'УК-4',
                            cat:"Коммуникация",
                            desc:"Способен осуществлять деловую коммуникацию в устной и письменной формах на государственном языке Российской Федерации и иностранном(ых) языке(ах)"
                        },
                        {code: 'УК-5',
                            cat:"Межкультурное взаимодействие",
                            desc:"Способен воспринимать межкультурное разнообразие общества в социально-историческом, этическом и философском контекстах"
                        },
                        {code: 'УК-6',
                            cat:"Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc:"Способен управлять своим временем, выстраивать и реализовывать траекторию саморазвития на основе принципов образования в течение всей жизни"
                        },
                        {code: 'УК-7',
                            cat:"Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc:"Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {code: 'УК-8',
                            cat:"Безопасность жизнедеятельности",
                            desc:"Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {code: 'УК-9',
                            cat:"Экономическая культура, в том числе финансовая грамотность",
                            desc:"Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {code: 'УК-10',
                            cat:"Гражданская позиция",
                            desc:"Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],

                    OPK:[]
                },
                '37.05.01':{
                    UK:[{code: 'УК-1',
                        cat:"Системное и критическое мышление",
                        desc:"Способен осуществлять критический анализ проблемных ситуаций на основе системного подхода, вырабатывать стратегию действий"
                    },
                        {code: 'УК-2',
                            cat:"Разработка и реализация проектов",
                            desc:"Способен управлять проектом на всех этапах его жизненного цикла"
                        },
                        {code: 'УК-3',
                            cat:"Командная работа и лидерство",
                            desc:"Способен организовывать и руководить работой команды, вырабатывая командную стратегию для достижения поставленной цели"
                        },
                        {code: 'УК-4',
                            cat:"Коммуникация",
                            desc:"Способен применять современные коммуникативные технологии, в том числе на иностранном(ых) языке(ах), для академического и профессионального взаимодействия"
                        },
                        {code: 'УК-5',
                            cat:"Межкультурное взаимодействие",
                            desc:"Способен анализировать и учитывать разнообразие культур в процессе межкультурного взаимодействия"
                        },
                        {code: 'УК-6',
                            cat:"Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc:"Способен определять и реализовывать приоритеты собственной деятельности и способы ее совершенствования на основе самооценки и образования в течение всей жизни"
                        },
                        {code: 'УК-7',
                            cat:"Самоорганизация и саморазвитие (в том числе здоровьесбережение)",
                            desc:"Способен поддерживать должный уровень физической подготовленности для обеспечения полноценной социальной и профессиональной деятельности"
                        },
                        {code: 'УК-8',
                            cat:"Безопасность жизнедеятельности",
                            desc:"Способен создавать и поддерживать в повседневной жизни и в профессиональной деятельности безопасные условия жизнедеятельности для сохранения природной среды, обеспечения устойчивого развития общества, в том числе при угрозе и возникновении чрезвычайных ситуаций и военных конфликтов"
                        },
                        {code: 'УК-9',
                            cat:"Инклюзивная компетентность",
                            desc:"Способен использовать базовые дефектологические знания в социальной и профессиональной сферах"
                        },
                        {code: 'УК-10',
                            cat:"Экономическая культура, в том числе финансовая грамотность",
                            desc:" Способен принимать обоснованные экономические решения в различных областях жизнедеятельности"
                        },
                        {code: 'УК-11',
                            cat:"Гражданская позиция",
                            desc:"Способен формировать нетерпимое отношение к проявлениям экстремизма, терроризма, коррупционному поведению и противодействовать им в профессиональной деятельности"
                        }],

                    OPK:[{code:'ОПК-1',
                        cat:"Исследование и оценка",
                        desc:"Способен осуществлять научное исследование в сфере профессиональной деятельности на основе современной методологии "
                    },
                        {code:'ОПК-2',
                            cat:"Исследование и оценка",
                            desc:"Способен применять научно обоснованные методы оценки уровня психического развития, состояния когнитивных функций эмоциональной сферы, развития личности, социальной адаптации различных категорий населения"
                        },
                        {code:'ОПК-3',
                            cat:"Психологическая оценка, диагностика и экспертиза",
                            desc:"Способен применять надежные и валидные способы количественной и качественной психологической оценки при решении научных, прикладных и экспертных задач, связанных со здоровьем человека, в том числе с учетом принципов персонализированной медицины "
                        },
                        {code:'ОПК-4',
                            cat:"Психологическая оценка, диагностика и экспертиза",
                            desc:"Способен вести протокол и составлять заключение по результатам психологической диагностики и экспертизы, а также представлять обратную связь по запросу заказчика"
                        },
                        {code:'ОПК-5',
                            cat:"Психологическое вмешательство",
                            desc:"Способен разрабатывать и использовать научно обоснованные программы психологического вмешательства и психологической помощи консультационного, развивающего, коррекционного, психотерапевтического, профилактического или реабилитационного характера для решения конкретной проблемы отдельных лиц и групп населения и (или) организаций, в том числе лицам с ОВЗ"
                        },
                        {code:'ОПК-6',
                            cat:"Психологическое консультирование",
                            desc:"Способен разрабатывать и реализовывать комплексные программы предоставления психологических услуг по индивидуальному, семейному и групповому психологическому консультированию и неврачебной психотерапии как виду профессиональной деятельности клинического психолога"
                        },
                        {code:'ОПК-7',
                            cat:"Администрирование (организация и управление)",
                            desc:"Способен выполнять основные функции управления психологической практикой, разрабатывать и реализовывать психологические программы подбора персонала в соответствии с требованиями профессии, психофизиологическими возможностями и личностными характеристиками претендента, осуществлять управление коммуникациями и контролировать результаты работы"
                        },
                        {code:'ОПК-8',
                            cat:"Преподавание (обучение)",
                            desc:"Способен разрабатывать и реализовывать программы обучения основам клинической психологии и психологии здоровья, в том числе здоровьесберегающим технологиям в соответствии с образовательными потребностями представителей различных групп населения (групп риска, уязвимых категорий населения, лиц с ОВЗ), включая инклюзивное образование"
                        },
                        {code:'ОПК-9',
                            cat:"Психологическая профилактика",
                            desc:"Способен осуществлять психолого-профилактическую деятельность среди различных категорий населения с целью повышения уровня их психологической грамотности и культуры, формирования научно-обоснованных знаний и представлений о роли психологии в решении социально- и индивидуально значимых проблем и задач в сфере охраны здоровья и смежных с ней областей"
                        },
                        {code:'ОПК-10',
                            cat:"Супервизия",
                            desc:"Способен использовать системные модели и методы, способы и приемы супервизии, в том числе профессиональную рефлексию и профессиональную коммуникацию для повышения уровня собственной компетентности и компетентности других специалистов в решении ключевых задач профессиональной деятельности"
                        },
                        {code:'ОПК-11',
                            cat:"Информационно-коммуникационные технологии для профессиональной деятельности",
                            desc:"Способен понимать принципы работы современных информационных технологий и использовать их для решения задач профессиональной деятельности"
                        }]
                },
                '1.3.8.':{
                    UK:[],
                    OPK:[]
                },
                '1.2.2.':{
                    UK:[],
                    OPK:[]
                },
                '1.6.10.':{
                    UK:[],
                    OPK:[]
                },
                '05.06.01':{
                    UK:[],
                    OPK:[]
                },
                '2.4.3.':{
                    UK:[],
                    OPK:[]
                },
                '5.3.4.':{
                    UK:[],
                    OPK:[]
                },
                '5.2.3.':{
                    UK:[],
                    OPK:[]
                },
                '5.1.1.':{
                    UK:[],
                    OPK:[]
                },
                '5.8.7.':{
                    UK:[],
                    OPK:[]
                },
                '5.9.1.':{
                    UK:[],
                    OPK:[]
                },
                '5.9.8.':{
                    UK:[],
                    OPK:[]
                },
                '5.7.9.':{
                    UK:[],
                    OPK:[]
                },
                '5.12.3.':{
                    UK:[],
                    OPK:[]
                },
                '09.02.01':{
                    UK:[{code: 'ОК 01.',
                        cat:"ОК 01.",
                        desc:"Выбирать способы решения задач профессиональной деятельности, применительно к различным контекстам."
                    },
                        {code: 'ОК 02.',
                            cat:"ОК 02.",
                            desc:"Использовать современные средства поиска, анализа и интерпретации информации и информационные технологии для выполнения задач профессиональной деятельности."
                        },
                        {code: 'ОК 03.',
                            cat:"ОК 03.",
                            desc:"Планировать и реализовывать собственное профессиональное и личностное развитие, предпринимательскую деятельность в профессиональной сфере, использовать знания по правовой и финансовой грамотности в различных жизненных ситуациях."
                        },
                        {code: 'ОК 04.',
                            cat:"ОК 04.",
                            desc:"Эффективно взаимодействовать и работать в коллективе и команде."
                        },
                        {code: 'ОК 05.',
                            cat:"ОК 05.",
                            desc:"Осуществлять устную и письменную коммуникацию на государственном языке Российской Федерации с учетом особенностей социального и культурного контекста."
                        },
                        {code: 'ОК 06.',
                            cat:"ОК 06.",
                            desc:"Проявлять гражданско-патриотическую позицию, демонстрировать осознанное поведение на основе традиционных российских духовно-нравственных ценностей, в том числе с учетом гармонизации межнациональных и межрелигиозных отношений, применять стандарты антикоррупционного поведения."
                        },
                        {code: 'ОК 07.',
                            cat:"ОК 07.",
                            desc:"Содействовать сохранению окружающей среды, ресурсосбережению, применять знания об изменении климата, принципы бережливого производства, эффективно действовать в чрезвычайных ситуациях."
                        },
                        {code: 'ОК 08.',
                            cat:"ОК 08.",
                            desc:"Использовать средства физической культуры для сохранения и укрепления здоровья в процессе профессиональной деятельности и поддержания необходимого уровня физической подготовленности."
                        },
                        {code: 'ОК 09.',
                            cat:"ОК 09.",
                            desc:"Пользоваться профессиональной документацией на государственном и иностранном языках."
                        }],

                    OPK:[{code: "ПК 1.1.",
                        cat:"проектирование цифровых систем",
                        desc:"Анализировать требования технического задания на проектирование цифровых систем."
                    },
                        {code: 'ПК 1.2.',
                            cat:"проектирование цифровых систем",
                            desc:"Разрабатывать схемы электронных устройств на основе интегральных схем разной степени интеграции в соответствии с техническим заданием."
                        },
                        {code: 'ПК 1.3.',
                            cat:"проектирование цифровых систем",
                            desc:"Оформлять техническую документацию на проектируемые устройства."
                        },
                        {code: 'ПК 1.4.',
                            cat:"проектирование цифровых систем",
                            desc:"Выполнять прототипирование цифровых систем, в том числе - с применением виртуальных средств."
                        },
                        {code: 'ПК 2.1.',
                            cat:"проектирование управляющих программ компьютерных систем и комплексов",
                            desc:"Проектировать, разрабатывать и отлаживать программный код модулей управляющих программ."
                        },
                        {code: 'ПК 2.2.',
                            cat:"проектирование управляющих программ компьютерных систем и комплексов",
                            desc:"Владеть методами командной разработки программных продуктов."
                        },
                        {code: 'ПК 2.3.',
                            cat:"проектирование управляющих программ компьютерных систем и комплексов",
                            desc:"Выполнять интеграцию модулей в управляющую программу."
                        },
                        {code: 'ПК 2.4.',
                            cat:"проектирование управляющих программ компьютерных систем и комплексов",
                            desc:"Тестировать и верифицировать выпуски управляющих программ."
                        },
                        {code: 'ПК 2.5.',
                            cat:"проектирование управляющих программ компьютерных систем и комплексов",
                            desc:"Выполнять установку и обновление версий управляющих программ (с учетом миграции - при необходимости)."
                        },
                        {code: 'ПК 3.1.',
                            cat:"техническое обслуживание и ремонт компьютерных систем и комплексов",
                            desc:"Проводить контроль параметров, диагностику и восстановление работоспособности цифровых устройств компьютерных систем и комплексов."
                        },
                        {code: 'ПК 3.2.',
                            cat:"техническое обслуживание и ремонт компьютерных систем и комплексов",
                            desc:"Проверять работоспособность, выполнять обнаружение и устранять дефекты программного кода управляющих программ компьютерных систем и комплексов."
                        },
                        {code: 'ПК 4.1.',
                            cat:"ПК 4.1.",
                            desc:"Создавать и обрабатывать информацию различных видов"
                        }],
                },
                '09.02.07':{
                    UK:[{code: 'ОК 01.',
                        cat:"ОК 01.",
                        desc:"Выбирать способы решения задач профессиональной деятельности применительно к различным контекстам."
                    },
                        {code: 'ОК 02.',
                            cat:"ОК 02.",
                            desc:"Использовать современные средства поиска, анализа и интерпретации информации и информационные технологии для выполнения задач профессиональной деятельности."
                        },
                        {code: 'ОК 03.',
                            cat:"ОК 03.",
                            desc:"Планировать и реализовывать собственное профессиональное и личностное развитие, предпринимательскую деятельность в профессиональной сфере, использовать знания по правовой и финансовой грамотности в различных жизненных ситуациях."
                        },
                        {code: 'ОК 04.',
                            cat:"ОК 04.",
                            desc:"Эффективно взаимодействовать и работать в коллективе и команде."
                        },
                        {code: 'ОК 05.',
                            cat:"ОК 05.",
                            desc:"Осуществлять устную и письменную коммуникацию на государственном языке Российской Федерации с учетом особенностей социального и культурного контекста."
                        },
                        {code: 'ОК 06.',
                            cat:"ОК 06.",
                            desc:"Проявлять гражданско-патриотическую позицию, демонстрировать осознанное поведение на основе традиционных российских духовно-нравственных ценностей, в том числе с учетом гармонизации межнациональных и межрелигиозных отношений, применять стандарты антикоррупционного поведения."
                        },
                        {code: 'ОК 07.',
                            cat:"ОК 07.",
                            desc:"Содействовать сохранению окружающей среды, ресурсосбережению, применять знания об изменении климата, принципы бережливого производства, эффективно действовать в чрезвычайных ситуациях."
                        },
                        {code: 'ОК 08.',
                            cat:"ОК 08.",
                            desc:"Использовать средства физической культуры для сохранения и укрепления здоровья в процессе профессиональной деятельности и поддержания необходимого уровня физической подготовленности."
                        },
                        {code: 'ОК 09.',
                            cat:"ОК 09.",
                            desc:"Пользоваться профессиональной документацией на государственном и иностранном языках."
                        }],

                    OPK:[{code: "ПК 1.1.",
                        cat:"ПК 1.1.",
                        desc:"Формировать алгоритмы разработки программных модулей в соответствии с техническим заданием."
                    },
                        {code: 'ПК 1.2.',
                            cat:"ПК 1.2.",
                            desc:"Разрабатывать программные модули в соответствии с техническим заданием."
                        },
                        {code: 'ПК 1.3.',
                            cat:"ПК 1.3.",
                            desc:"Выполнять отладку программных модулей с использованием специализированных программных средств"
                        },
                        {code: 'ПК 1.4.',
                            cat:"ПК 1.4.",
                            desc:"Выполнять тестирование программных модулей."
                        },
                        {code: 'ПК 1.5.',
                            cat:"ПК 1.5.",
                            desc:"Осуществлять рефакторинг и оптимизацию программного кода."
                        },
                        {code: 'ПК 1.6.',
                            cat:"ПК 1.6.",
                            desc:"Разрабатывать модули программного обеспечения для мобильных платформ."
                        },
                        {code: 'ПК 2.1.',
                            cat:"ПК 2.1.",
                            desc:"Разрабатывать требования к программным модулям на основе анализа проектной и технической документации на предмет взаимодействия компонент."
                        },
                        {code: 'ПК 2.2.',
                            cat:"ПК 2.2.",
                            desc:"Выполнять интеграцию модулей в программное обеспечение."
                        },
                        {code: 'ПК 2.3.',
                            cat:"ПК 2.3.",
                            desc:"Выполнять отладку программного модуля с использованием специализированных программных средств."
                        },
                        {code: 'ПК 2.4.',
                            cat:"ПК 2.4.",
                            desc:"Осуществлять разработку тестовых наборов и тестовых сценариев для программного обеспечения."
                        },
                        {code: 'ПК 2.5.',
                            cat:"ПК 2.5.",
                            desc:"Производить инспектирование компонент программного обеспечения на предмет соответствия стандартам кодирования."
                        },
                        {code: 'ПК 4.1.',
                            cat:"ПК 4.1.",
                            desc:"Осуществлять инсталляцию, настройку и обслуживание программного обеспечения компьютерных систем."
                        },
                        {code: 'ПК 4.2.',
                            cat:"ППК 4.2.",
                            desc:"Осуществлять измерения эксплуатационных характеристик программного обеспечения компьютерных систем."
                        },
                        {code: 'ПК 4.3.',
                            cat:"ПК 4.3.",
                            desc:"Выполнять работы по модификации отдельных компонент программного обеспечения в соответствии с потребностями заказчика."
                        },
                        {code: 'ПК 4.4.',
                            cat:"ПК 4.4.",
                            desc:"Обеспечивать защиту программного обеспечения компьютерных систем программными средствами."
                        },
                        {code: 'ПК 11.1.',
                            cat:"ПК 11.1.",
                            desc:"Осуществлять сбор, обработку и анализ информации для проектирования баз данных."
                        },
                        {code: 'ПК 11.2.',
                            cat:"ПК 11.2.",
                            desc:"Проектировать базу данных на основе анализа предметной области."
                        },
                        {code: 'ПК 11.3.',
                            cat:"ПК 11.3.",
                            desc:"Разрабатывать объекты базы данных в соответствии с результатами анализа предметной области."
                        },
                        {code: 'ПК 11.4.',
                            cat:"ПК 11.4.",
                            desc:"Реализовывать базу данных в конкретной системе управления базами данных."
                        },
                        {code: 'ПК 11.5.',
                            cat:"ПК 11.5.",
                            desc:"Администрировать базы данных."
                        },
                        {code: 'ПК 11.6.',
                            cat:"ПК 11.6.",
                            desc:"Защищать информацию в базе данных с использованием технологии защиты информации."
                        }]
                },
                '10.02.04':{
                    UK:[{code: 'ОК 01.',
                        cat:"ОК 01.",
                        desc:"Выбирать способы решения задач профессиональной деятельности применительно к различным контекстам"
                        },
                        {code: 'ОК 02.',
                            cat:"ОК 02.",
                            desc:"Использовать современные средства поиска, анализа и интерпретации информации и информационные технологии для выполнения задач профессиональной деятельности"
                        },
                        {code: 'ОК 03.',
                            cat:"ОК 03.",
                            desc:"Планировать и реализовывать собственное профессиональное и личностное развитие, предпринимательскую деятельность в профессиональной сфере, использовать знания по правовой и финансовой грамотности в различных жизненных ситуациях."
                        },
                        {code: 'ОК 04.',
                            cat:"ОК 04.",
                            desc:"Эффективно взаимодействовать и работать в коллективе и команде."
                        },
                        {code: 'ОК 05.',
                            cat:"ОК 05.",
                            desc:"Осуществлять устную и письменную коммуникацию на государственном языке Российской Федерации с учетом особенностей социального и культурного контекста."
                        },
                        {code: 'ОК 06.',
                            cat:"ОК 06.",
                            desc:"Проявлять гражданско-патриотическую позицию, демонстрировать осознанное поведение на основе традиционных российских духовно-нравственных ценностей, в том числе с учетом гармонизации межнациональных и межрелигиозных отношений, применять стандарты антикоррупционного поведения"
                        },
                        {code: 'ОК 07.',
                            cat:"ОК 07.",
                            desc:"Содействовать сохранению окружающей среды, ресурсосбережению, применять знания об изменении климота, принципы бережливого производства, эффективно действовать в чрезвычайных ситуациях."
                        },
                        {code: 'ОК 08.',
                            cat:"ОК 08.",
                            desc:"Использовать средства физической культуры для сохранения и укрепления здоровья в процессе профессиональной деятельности и поддержания необходимого уровня физической подготовленности"
                        },
                        {code: 'ОК 09.',
                            cat:"ОК 09.",
                            desc:"Пользоваться профессиональной документацией на государственном и иностранном языках"
                        }],

                    OPK:[{code: "ПК 1.1.",
                        cat:"ПК 1.1.",
                        desc:"Производить монтаж, настройку,поверку функционирования и конфигурирование оборудования информационно–телекоммуникационных систем и сетей."
                    },
                        {code: 'ПК 1.2.',
                            cat:"ПК 1.2.",
                            desc:"Осуществлять диагностику технического состояния, поиск неисправностей и ремонт оборудования информационно–телекоммуникационных систем и сетей."
                        },
                        {code: 'ПК 1.3.',
                            cat:"ПК 1.3.",
                            desc:"Проводить техническое обслуживание оборудования информационно–телекоммуникационных систем и сетей"
                        },
                        {code: 'ПК 1.4.',
                            cat:"ПК 1.4.",
                            desc:"Осуществлять контроль функционирования информационно–телекоммуникационных систем и сетей"
                        },
                        {code: 'ПК 2.1.',
                            cat:"ПК 2.1.",
                            desc:"Производить установку, настройку, испытания и конфигурирование программных и программно-аппаратных, в том числе криптографических средств защиты информации от несанкционированного доступа и специальных воздействий в оборудование информационно–телекоммуникационных систем и сетей"
                        },
                        {code: 'ПК 2.2.',
                            cat:"ПК 2.2.",
                            desc:"Поддерживать бесперебойную работу программных и программно-аппаратных, в том числе и криптографических средств защиты информации в информационно-телекоммуникационных системах и сетях"
                        },
                        {code: 'ПК 2.3.',
                            cat:"ПК 2.3.",
                            desc:"Осуществлять защиту информации от несанкционированных действий и специальных воздействий в информационно–телекоммуникационных системах и сетях с использованием программных и программно-аппаратных, в том числе криптографических средств в соответствии с предъявленными требованиями."
                        },
                        {code: 'ПК 3.1.',
                            cat:"ПК 3.1.",
                            desc:"Производить установку, монтаж, настройку и испытания технических средств защиты информации от утечки по техническим каналам в информационно–телекоммуникационных системах и сетях."
                        },
                        {code: 'ПК 3.2.',
                            cat:"ПК 3.2.",
                            desc:"Проводить техническое обслуживание, диагностику, устранение неисправностей и ремонт технических средств защиты информации, используемых в информационно–телекоммуникационных системах и сетях"
                        },
                        {code: 'ПК 3.3.',
                            cat:"ПК 3.3.",
                            desc:"Осуществлять защиту информации от утечки по техническим каналам в информационно–телекоммуникационных системах и сетях с использованием технических средств защиты в соответствии с предъявляемыми требованиями."
                        },
                        {code: 'ПК 3.4.',
                            cat:"ПК 3.4.",
                            desc:"Проводить отдельные работы по физической защите линий связи информационно–телекоммуникационных систем и сетей."
                        },

                        {code: 'ПК 4.1.',
                            cat:"ПК 4.1.",
                            desc:"Создавать и обрабатывать информацию различных видов"
                        }],
                    },
                '13.02.13':{
                    UK:[{code: 'ОК 01.',
                        cat:"ОК 01.",
                        desc:"Выбирать способы решения задач профессиональной деятельности применительно к различным контекстам"
                        },
                        {code: 'ОК 02.',
                            cat:"ОК 02.",
                            desc:"Использовать современные средства поиска, анализа и интерпретации информации и информационные технологии для выполнения задач профессиональной деятельности"
                        },
                        {code: 'ОК 03.',
                            cat:"ОК 03.",
                            desc:"Планировать и реализовывать собственное профессиональное и личностное развитие, предпринимательскую деятельность в профессиональной сфере, использовать знания по правовой  и финансовой грамотности в различных жизненных ситуациях"
                        },
                        {code: 'ОК 04.',
                            cat:"ОК 04.",
                            desc:"Эффективно взаимодействовать и работать в коллективе и команде"
                        },
                        {code: 'ОК 05.',
                            cat:"ОК 05.",
                            desc:"Осуществлять устную и письменную коммуникацию на государственном языке Российской Федерации с учетом особенностей социального и культурного контекста"
                        },
                        {code: 'ОК 06.',
                            cat:"ОК 06.",
                            desc:"Проявлять гражданско-патриотическую позицию, демонстрировать осознанное поведение на основе традиционных российских духовно-нравственных ценностей, в том числе с учетом гармонизации межнациональных и межрелигиозных отношений, применять стандарты антикоррупционного поведения"
                        },
                        {code: 'ОК 07.',
                            cat:"ОК 07.",
                            desc:"Содействовать сохранению окружающей среды, ресурсосбережению, применять знания об изменении климата, принципы бережливого производства, эффективно действовать в чрезвычайных ситуациях"
                        },
                        {code: 'ОК 08.',
                            cat:"ОК 08.",
                            desc:"Использовать средства физической культуры для сохранения и укрепления здоровья в процессе профессиональной деятельности и поддержания необходимого уровня физической подготовленности"
                        },
                        {code: 'ОК 09.',
                            cat:"ОК 09.",
                            desc:"Пользоваться профессиональной документацией на государственном и иностранном языках"
                        }],

                    OPK:[{code: "ПК 1.1.",
                        cat:"Осуществление технического обслуживания и ремонта электрического и электромеханического оборудования",
                        desc:"Выполнять операции по техническому обслуживанию и ремонту электрического и электромеханического оборудования."
                        },
                        {code: 'ПК 1.2.',
                            cat:"Осуществление технического обслуживания и ремонта электрического и электромеханического оборудования",
                            desc:"Проводить диагностику и испытания электрического и электромеханического оборудования."
                        },
                        {code: 'ПК 1.3.',
                            cat:"Осуществление технического обслуживания и ремонта электрического и электромеханического оборудования",
                            desc:"Осуществлять оценку производственно-технических показателей работы эклектического и электромеханического оборудования."
                        },
                        {code: 'ПК 2.1.',
                            cat:"Организационное обеспечение эксплуатации, технического обслуживания и ремонта электрического и электромеханического оборудования",
                            desc:"Осуществлять планирование работ по эксплуатации электрического и электромеханического оборудования."
                        },
                        {code: 'ПК 2.2.',
                            cat:"Организационное обеспечение эксплуатации, технического обслуживания и ремонта электрического и электромеханического оборудования",
                            desc:"Разрабатывать документацию по эксплуатации электрического и электромеханического оборудования."
                        },
                        {code: 'ПК 2.3.',
                            cat:"Организационное обеспечение эксплуатации, технического обслуживания и ремонта электрического и электромеханического оборудования",
                            desc:"Контролировать соблюдение персоналом требований охраны труда, промышленной и пожарной безопасности."
                        },
                        {code: 'ПК 3.1.',
                            cat:"Осуществление технического обслуживания и ремонта электрического и электромеханического оборудования энергоустановок",
                            desc:"Проводить диагностику технического состояния электрического и электромеханического оборудования энергоустановок."
                        },
                        {code: 'ПК 3.2.',
                            cat:"Осуществление технического обслуживания и ремонта электрического и электромеханического оборудования энергоустановок",
                            desc:"Осуществлять проведение работ по техническому обслуживанию и ремонту электрического и электромеханического оборудования энергоустановок."
                        },
                        {code: 'ПК 4.1.',
                            cat:"Освоение профессии рабочего, должности служащего",
                            desc:"Выполнение слесарных, монтажных работ, разборку и сборку электроустановок и оборудования при выполнении ремонтов;"
                        }]
                    },
                '18.02.12':{
                    UK:[{code: 'ОК 01.',
                        cat:"ОК 01.",
                        desc:"Выбирать способы решения задач профессиональной деятельности применительно к различным контекстам."
                        },
                        {code: 'ОК 02.',
                            cat:"ОК 02.",
                            desc:"Использовать современные средства поиска, анализа и интерпретации информации и информационные технологии для выполнения задач профессиональной деятельности."
                        },
                        {code: 'ОК 03.',
                            cat:"ОК 03.",
                            desc:"Планировать и реализовывать собственное профессиональное и личностное развитие, предпринимательскую деятельность в профессиональной сфере, использовать знания по правовой и финансовой грамотности в различных жизненных ситуациях."
                        },
                        {code: 'ОК 04.',
                            cat:"ОК 04.",
                            desc:"Эффективно взаимодействовать и работать в коллективе и команде."
                        },
                        {code: 'ОК 05.',
                            cat:"ОК 05.",
                            desc:"Осуществлять устную и письменную коммуникацию на государственном языке Российской Федерации с учетом особенностей социального и культурного контекста."
                        },
                        {code: 'ОК 06.',
                            cat:"ОК 06.",
                            desc:"Проявлять гражданско-патриотическую позицию, демонстрировать осознанное поведение на основе традиционных российских духовно-нравственных ценностей, в том числе с учетом гармонизации межнациональных и межрелигиозных отношений, применять стандарты антикоррупционного поведения."
                        },
                        {code: 'ОК 07.',
                            cat:"ОК 07.",
                            desc:"Содействовать сохранению окружающей среды, ресурсосбережению, применять знания об изменении климата, принципы бережливого производства, эффективно действовать в чрезвычайных ситуациях."
                        },
                        {code: 'ОК 08.',
                            cat:"ОК 08.",
                            desc:"Использовать средства физической культуры для сохранения и укрепления здоровья в процессе профессиональной деятельности и поддержания необходимого уровня физической подготовленности."
                        },
                        {code: 'ОК 09.',
                            cat:"ОК 09.",
                            desc:"Пользоваться профессиональной документацией на государственном и иностранном языках"
                        }],

                    OPK:[{code: "ПК 1.1.",
                            cat:"ПК 1.1.",
                            desc:"Оценивать соответствие методики задачам анализа по диапазону измеряемых значений и точности"
                        },
                        {code: 'ПК 1.2.',
                            cat:"ПК 1.2.",
                            desc:"Выбирать оптимальные методы анализа."
                        },
                        {code: 'ПК 1.3.',
                            cat:"ПК 1.3.",
                            desc:"Подготавливать реагенты, материалы и растворы, необходимые для анализа."
                        },
                        {code: 'ПК 1.4.',
                            cat:"ПК 1.4.",
                            desc:"Работать с химическими веществами и оборудованием с соблюдением отраслевых норм и экологической безопасности."
                        },
                        {code: 'ПК 2.1.',
                            cat:"ПК 2.1.",
                            desc:"Обслуживать и эксплуатировать лабораторное оборудование, испытательное оборудование и средства измерения химико-аналитических лабораторий."
                        },
                        {code: 'ПК 2.2.',
                            cat:"ПК 2.2.",
                            desc:"Проводить качественный и количественный анализ неорганических и органических веществ химическими и физико-химическими методами"
                        },
                        {code: 'ПК 2.3.',
                            cat:"ПК 2.3.",
                            desc:"Проводить метрологическую обработку результатов анализов"
                        },
                        {code: 'ПК 3.1.',
                            cat:"ПК 3.1.",
                            desc:"Планировать и организовывать работу в соответствии со стандартами предприятия, международными стандартами и другим требованиями."
                        },
                        {code: 'ПК 3.2.',
                            cat:"ПК 3.2.",
                            desc:"Организовывать безопасные условия процессов и производства."
                        },
                        {code: 'ПК 3.3.',
                            cat:"ПК 3.3.",
                            desc:"Анализировать производственную деятельность лаборатории и оценивать экономическую эффективность работы"
                        },
                        {code: 'ПК 4.1.',
                            cat:"ПК 4.1.",
                            desc:"Выполнять отбор проб природных и промышленных материалов"
                        },
                        {code: 'ПК 4.2.',
                            cat:"ПК 4.2.",
                            desc:"Подготавливать лабораторное оборудование к проведению испытаний и эксплуатировать его в соответствии с документацией"
                        },
                        {code: 'ПК 4.3.',
                            cat:"ПК 4.3.",
                            desc:"Выполнять испытания природных и промышленных материалов"

                        }]
                    },
                '21.02.13':{
                    UK:[{code: 'ОК 01.',
                        cat:"ОК 01.",
                        desc:"Выбирать способы решения задач профессиональной деятельности, применительно к различным контекстам."
                    },
                        {code: 'ОК 02.',
                            cat:"ОК 02.",
                            desc:"Использовать современные средства поиска, анализа и интерпретации информации и информационные технологии для выполнения задач профессиональной деятельности."
                        },
                        {code: 'ОК 03.',
                            cat:"ОК 03.",
                            desc:"Планировать и реализовывать собственное профессиональное и личностное развитие, предпринимательскую деятельность в профессиональной сфере, использовать знания по правовой и финансовой грамотности в различных жизненных ситуациях."
                        },
                        {code: 'ОК 04.',
                            cat:"ОК 04.",
                            desc:"Эффективно взаимодействовать и работать в коллективе и команде."
                        },
                        {code: 'ОК 05.',
                            cat:"ОК 05.",
                            desc:"Осуществлять устную и письменную коммуникацию на государственном языке Российской Федерации с учетом особенностей социального и культурного контекста."
                        },
                        {code: 'ОК 06.',
                            cat:"ОК 06.",
                            desc:"Проявлять гражданско-патриотическую позицию, демонстрировать осознанное поведение на основе традиционных российских духовно-нравственных ценностей, в том числе с учетом гармонизации межнациональных и межрелигиозных отношений, применять стандарты антикоррупционного поведения."
                        },
                        {code: 'ОК 07.',
                            cat:"ОК 07.",
                            desc:"Содействовать сохранению окружающей среды, ресурсосбережению, применять знания об изменении климата, принципы бережливого производства, эффективно действовать в чрезвычайных ситуациях."
                        },
                        {code: 'ОК 08.',
                            cat:"ОК 08.",
                            desc:"Использовать средства физической культуры для сохранения и укрепления здоровья в процессе профессиональной деятельности и поддержания необходимого уровня физической подготовленности."
                        },
                        {code: 'ОК 09.',
                            cat:"ОК 09.",
                            desc:"Пользоваться профессиональной документацией на государственном и иностранном языках"
                        }],

                    OPK:[{code: "ПК 1.1.",
                            cat:"ПК 1.1.",
                            desc:"Проводить полевые геологические исследования и работы с получением первичного геологического материала."
                        },
                        {code: 'ПК 1.2.',
                            cat:"ПК 1.2.",
                            desc:"Разрабатывать методики и техники полевых работ по отдельным методам геологических исследований."
                        },
                        {code: 'ПК 1.3.',
                            cat:"ПК 1.3.",
                            desc:"Выполнять полевое обследование месторождений полезных ископаемых."
                        },
                        {code: 'ПК 1.4.',
                            cat:"ПК 1.4.",
                            desc:"Использовать современные технологии поиска и разведки месторождений полезных ископаемых."
                        },
                        {code: 'ПК 1.5.',
                            cat:"ПК 1.5.",
                            desc:"Выполнять предварительную обработку результатов полевых работ с применением современных программных средств."
                        },
                        {code: 'ПК 1.6.',
                            cat:"ПК 1.6.",
                            desc:"Проводить описание и замеры объектов геологических наблюдений."
                        },
                        {code: 'ПК 1.7.',
                            cat:"ПК 1.7.",
                            desc:"Осуществлять отбор образцов горных пород, керна и всех видов проб."
                        },
                        {code: 'ПК 1.8.',
                            cat:"ПК 1.8.",
                            desc:"Выполнять физический анализ образцов и проб в полевых условиях."
                        },
                        {code: 'ПК 2.1.',
                            cat:"ПК 2.1.",
                            desc:"Организовывать и управлять процессами подготовки геологических материалов, снаряжения, техники и оборудования в соответствии с полученным заданием."
                        },
                        {code: 'ПК 2.2.',
                            cat:"ПК 2.2.",
                            desc:"Определять виды и типы материалов, снаряжения, техники и оборудования для проведения геологических исследований."
                        },
                        {code: 'ПК 2.3.',
                            cat:"ПК 2.3.",
                            desc:"Осуществлять самостоятельный контроль подготовки материалов и оборудования."
                        },
                        {code: 'ПК 2.4.',
                            cat:"ПК 2.4.",
                            desc:"Использовать компьютерные и спутниковые технологии для автоматизации полевых измерений"
                        },
                        {code: 'ПК 2.5.',
                            cat:"ПК 2.5.",
                            desc:"Использовать специальные геологические приборы и инструменты, предназначенные для решения задач поиска и разведки месторождений, выполнять их исследование, поверки и юстировку."
                        },
                        {code: 'ПК 3.1.',
                            cat:"ПК 3.1.",
                            desc:"Разрабатывать мероприятия и организовывать работы при поисках и разведке месторождений полезных ископаемых."
                        },
                        {code: 'ПК 3.2.',
                            cat:"ПК 3.2.",
                            desc:"Принимать решения по комплектованию структурного подразделения исполнителей и организации работы струртурного подразделения."
                        },
                        {code: 'ПК 3.3.',
                            cat:"ПК 3.3.",
                            desc:"Реализовывать мероприятия по повышению эффективности работ, направленных на снижение трудоемкости и повышение производительности труда."
                        },
                        {code: 'ПК 3.4.',
                            cat:"ПК 3.4.",
                            desc:"Обеспечивать безопасное проведение работ."
                        },
                        {code: 'ПК 4.1.',
                            cat:"ПК 4.1.",
                            desc:"Выбирать технологию, оборудование, элементы крепления, инструменты для поверхностных и подземных проходческих работ."
                        },
                        {code: 'ПК 4.2.',
                            cat:"ПК 4.2.",
                            desc:"Принимать меры к предупреждению отказов и аварий."
                        },
                        {code: 'ПК 4.3.',
                            cat:"ПК 4.3.",
                            desc:"Проводить и контролировать вентиляцию, освещение, водоотлив скважин при проведении горных работ."
                        },
                        {code: 'ПК 4.4.',
                            cat:"ПК 4.4.",
                            desc:"Оформлять документацию и производить расчеты, связанные с горнопроходческими и буровыми работами."
                        },
                        {code: 'ПК 4.5.',
                            cat:"ПК 4.5.",
                            desc:"Обеспечивать безопасность проведения буровых и горных работ."
                        },
                        {code: 'ПК 4.6.',
                            cat:"ПК 4.6.",
                            desc:"Выбирать способ разработки месторождений полезных ископаемых."
                        }],
                    },
                '38.02.01':{
                    UK:[{code: 'ОК 01.',
                            cat:"ОК 01.",
                            desc:"Выбирать способы решения задач профессиональной деятельности применительно к различным контекстам."
                        },
                        {code: 'ОК 02.',
                            cat:"ОК 02.",
                            desc:"Использовать современные средства поиска, анализа и интерпретации информации и информационные технологии для выполнения задач профессиональной деятельности."
                        },
                        {code: 'ОК 03.',
                            cat:"ОК 03.",
                            desc:"Планировать и реализовывать собственное профессиональное и личностное развитие, предпринимательскую деятельность в профессиональной сфере, использовать знания по правовой и финансовой грамотности в различных жизненных ситуациях."
                        },
                        {code: 'ОК 04.',
                            cat:"ОК 04.",
                            desc:"Эффективно взаимодействовать и работать в коллективе и команде."
                        },
                        {code: 'ОК 05.',
                            cat:"ОК 05.",
                            desc:"Осуществлять устную и письменную коммуникацию на государственном языке Российской Федерации с учетом особенностей социального и культурного контекста."
                        },
                        {code: 'ОК 06.',
                            cat:"ОК 06.",
                            desc:"Проявлять гражданско-патриотическую позицию, демонстрировать осознанное поведение на основе традиционных российских духовно-нравственных ценностей, в том числе с учетом гармонизации межнациональных и межрелигиозных отношений, применять стандарты антикоррупционного поведения."
                        },
                        {code: 'ОК 07.',
                            cat:"ОК 07.",
                            desc:"Содействовать сохранению окружающей среды, ресурсосбережению, применять знания об изменении климата, принципы бережливого производства, эффективно действовать в чрезвычайных ситуациях."
                        },
                        {code: 'ОК 08.',
                            cat:"ОК 08.",
                            desc:"Использовать средства физической культуры для сохранения и укрепления здоровья в процессе профессиональной деятельности и поддержания необходимого уровня физической подготовленности."
                        },
                        {code: 'ОК 09.',
                            cat:"ОК 09.",
                            desc:"Пользоваться профессиональной документацией на государственном и иностранном языках."
                        }],

                        OPK:[{code: "ПК 1.1.",
                            cat:"ПК 1.1.",
                            desc:"Составлять и обрабатывать первичные учетные документы о фактах хозяйственной деятельности экономического субъекта."
                        },
                        {code: 'ПК 1.2.',
                            cat:"ПК 1.2.",
                            desc:"Проводить денежное измерение объектов бухгалтерского учета."
                        },
                        {code: 'ПК 1.3.',
                            cat:"ПК 1.3.",
                            desc:"Проводить расчет налогов и сборов."
                        },
                        {code: 'ПК 1.4.',
                            cat:"ПК 1.4.",
                            desc:"Применять рабочий план счетов бухгалтерского учета организации."
                        },
                        {code: 'ПК 1.5.',
                            cat:"ПК 1.5.",
                            desc:"Осуществлять текущую группировку и итоговое обобщение фактов хозяйственной деятельности."
                        },
                        {code: 'ПК 1.6.',
                            cat:"ПК 1.6.",
                            desc:"Использовать цифровые технологии ведения бухгалтерского учета и формирования отчетности."
                        },
                        {code: 'ПК 2.1.',
                            cat:"ПК 2.1.",
                            desc:"Проводить инвентаризацию активов и обязательств экономического субъека и отражать ее результаты."
                        },
                        {code: 'ПК 2.2.',
                            cat:"ПК 2.2.",
                            desc:"Формировать бухгалтерскую (финансовыую) и налоговую отчетность."
                        },
                        {code: 'ПК 2.3.',
                            cat:"ПК 2.3.",
                            desc:"Оценивать достоверность формирования бухгалтерской (финансовой) и налоговой отчетности."
                        },
                        {code: 'ПК 2.4.',
                            cat:"ПК 2.4.",
                            desc:"Проводить анализ бухгалтерской (финансовой) отчетности."
                        },
                        {code: 'ПК 2.5.',
                            cat:"ПК 2.5.",
                            desc:"Составлять финансовую модель бизнес-плана."
                        }],
                    },
                '40.02.04':{
                    UK:[{code: 'ОК 01.',
                            cat:"ОК 01.",
                            desc:"Выбирать способы решения задач профессиональной деятельности применительно к различным контекстам"
                        },
                        {code: 'ОК 02.',
                            cat:"ОК 02.",
                            desc:"Использовать современные средства поиска, анализа и интерпретации информации и информационные технологии для выполнения задач профессиональной деятельности"
                        },
                        {code: 'ОК 03.',
                            cat:"ОК 03.",
                            desc:"Планировать и реализовывать собственное профессиональное и личностное развитие, предпринимательскую деятельность в профессиональной сфере, использовать знания по правовой и финансовой грамотности в различных жизненных ситуациях"
                        },
                        {code: 'ОК 04.',
                            cat:"ОК 04.",
                            desc:"Эффективно взаимодействовать и работать в коллективе и команде"
                        },
                        {code: 'ОК 05.',
                            cat:"ОК 05.",
                            desc:"Осуществлять устную и письменную коммуникацию на государственном языке Российской Федерации с учетом особенностей социального и культурного контекста"
                        },
                        {code: 'ОК 06.',
                            cat:"ОК 06.",
                            desc:"Проявлять гражданско-патриотическую позицию, демонстрировать осознанное поведение на основе традиционных общечеловеческих ценностей, в том числе с учетом гармонизации межнациональных и межрелигиозных отношений, применять стандарты антикоррупционного поведения"
                        },
                        {code: 'ОК 07.',
                            cat:"ОК 07.",
                            desc:"Содействовать сохранению окружающей среды, ресурсосбережению, применять знания об изменении климата, принципы бережливого производства, эффективно действовать в чрезвычайных ситуациях"
                        },
                        {code: 'ОК 08.',
                            cat:"ОК 08.",
                            desc:"Использовать средства физической культуры для сохранения и укрепления здоровья в процессе профессиональной деятельности и поддержания необходимого уровня физической подготовленности"
                        },
                        {code: 'ОК 09.',
                            cat:"ОК 09.",
                            desc:"Пользоваться профессиональной документацией на государственном и иностранном языках"
                        }],
                    OPK:[{code: "ПК 1.1.",
                            cat:"Правоприменительная деятельность",
                            desc:"Осуществлять профессиональное толкование норм права"
                        },
                        {code: 'ПК 1.2.',
                            cat:"Правоприменительная деятельность",
                            desc:"Применять нормы права для решения задач в профессиональной деятельности."
                        },
                        {code: 'ПК 1.3.',
                            cat:"Правоприменительная деятельность",
                            desc:"Владеть навыками подготовки юридических документов, в том числе с использованием информационных технологий."
                        },
                        {code: 'ПК 2.1.',
                            cat:"Правоохранительная деятельность",
                            desc:"Осуществлять контроль соблюдения законодательства Российской Федерации субъектами права"
                        },
                        {code: 'ПК 2.2.',
                            cat:"Правоохранительная деятельность",
                            desc:"Систематизировать нормативные правовые акты и обобщать правоприменительную практику по вопросам расследования и предупреждения преступлений и иных правонарушений."
                        },
                        {code: 'ПК 2.3.',
                            cat:"Правоохранительная деятельность",
                            desc:"Осуществлять оценку противоправного поведения и определять подведомственность рассмотрения дел."
                        },
                        {code: 'ПК 3.1.',
                            cat:"Обеспечение реализации прав граждан в сфере пенсионного обеспечения и социальной защиты",
                            desc:"Информировать на приеме и консультировании субъектов прав по вопросам социального обеспечения и социальной защиты."
                        },
                        {code: 'ПК 3.2.',
                            cat:"Обеспечение реализации прав граждан в сфере пенсионного обеспечения и социальной защиты",
                            desc:"Осуществлять формирование и рассмотрение пакета документов для установления и выплаты пенсий и иных социальных выплат и предоставления услуг государственного социального обеспечения, включая выдачу документов по указанным выплатам и услугам."
                        },
                        {code: 'ПК 3.3.',
                            cat:"Обеспечение реализации прав граждан в сфере пенсионного обеспечения и социальной защиты",
                            desc:"Осуществлять подготовку проектов решений об установлении (отказе в установлении) пенсий и иных социальных выплат и предоставлении услуг государственного социального обеспечения, используя информационно-коммуникационные технологии."
                        },
                        {code: 'ПК 3.4.',
                            cat:"Обеспечение реализации прав граждан в сфере пенсионного обеспечения и социальной защиты",
                            desc:"Осуществлять формирование и ведение баз данных об обращениях в территориальный орган Фонда пенсионного и социального страхования Российской Федерации, в организацию социальной защиты населения получателей пенсий и иных социальных выплат и о предоставлении услуг государственного социального обеспечения."
                        }],
                    },
                '43.02.16': {
                    UK: [{
                        code: "ОК 01.",
                        cat: "ОК 01.",
                        desc: "Выбирать способы решения задач профессиональной деятельности применительно к различным контекстам."
                    }, {
                        code: "ОК 02.",
                        cat: "ОК 02.",
                        desc: "Использовать современные средства поиска, анализа и интерпретации информации и информационные технологии для выполнения задач профессиональной деятельности."
                    }, {
                        code: "ОК 03.",
                        cat: "ОК 03.",
                        desc: "Планировать и реализовывать собственное профессиональное и личностное развитие, предпринимательскую деятельность в профессиональной сфере, использовать знания по правовой и финансовой грамотности в различных жизненных ситуациях."
                    }, {
                        code: "ОК 04.",
                        cat: "ОК 04.",
                        desc: "Эффективно взаимодействовать и работать в коллективе и команде."
                    }, {
                        code: "ОК 05.",
                        cat: "ОК 05.",
                        desc: "Осуществлять устную и письменную коммуникацию на государственном языке Российской Федерации с учетом особенностей социального и культурного контекста."
                    }, {
                        code: "ОК 06.",
                        cat: "ОК 06.",
                        desc: "Проявлять гражданско-патриотическую позицию, демонстрировать осознанное поведение на основе традиционных российских духовно-нравственных ценностей, в том числе с учетом гармонизации межнациональных и межрелигиозных отношений, применять стандарты антикоррупционного поведения."
                    }, {
                        code: "ОК 07.",
                        cat: "ОК 07.",
                        desc: "Содействовать сохранению окружающей среды, ресурсосбережению, применять знания об изменении климата, принципы бережливого производства, эффективно действовать в чрезвычайных ситуациях."
                    }, {
                        code: "ОК 08.",
                        cat: "ОК 08.",
                        desc: "Использовать средства физической культуры для сохранения и укрепления здоровья в процессе профессиональной деятельности и поддержания необходимого уровня физической подготовленности."
                    }, {
                        code: "ОК 09.",
                        cat: "ОК 09.",
                        desc: "Пользоваться профессиональной документацией на государственном и иностранном языках."
                    }],
                    OPK: [{
                        code: "ПК 1.1.",
                        cat: "ПК 1.1.",
                        desc: "Планировать текущую деятельность сотрудников служб предприятий туризма и гостеприимства"
                    }, {
                        code: "ПК 1.2.",
                        cat: "ПК 1.2.",
                        desc: "Организовывать текущую деятельность сотрудников служб предприятий туризма и гостеприимства"
                    }, {
                        code: "ПК 1.3.",
                        cat: "ПК 1.3.",
                        desc: "Координировать и контролировать деятельность сотрудников служб предприятий туризма и гостеприимства"
                    }, {
                        code: "ПК 1.4.",
                        cat: "ПК 1.4.",
                        desc: "Осуществлять расчеты с потребителями за предоставленные услуги"
                    }, {
                        code: "ПК 2.1.",
                        cat: "ПК 2.1.",
                        desc: "Оформлять и обрабатывать заказы клиентов"
                    }, {
                        code: "ПК 2.2.",
                        cat: "ПК 2.2.",
                        desc: "Координировать работу по реализации заказа"
                    },
                        {code: "ПК 3.1.",
                            cat: "ПК 3.1.",
                            desc: "Составление плана маршрута при занятиях пешеходным туризмом и трекингом."},
                        {code: "ДПК 3.2.",
                            cat: "ПК 3.2.",
                            desc: "Разработка плана действий при возникновении чрезвычайной ситуации или несчастном случае в группе при занятиях пешеходным туризмом и трекингом"
                        },
                        {code: "ПК 3.3.",
                            cat: "ПК 3.3.", desc: "Подготовка снаряжения необходимого для обеспечения безопасности группы при занятиях пешеходным туризмом и трекингом"}]
                    },
                '38.02.03': {
                    UK: [{
                        code: "ОК 01.",
                        cat: "ОК 01.",
                        desc: "Выбирать способы решения задач профессиональной деятельности, применительно к различным контекстам."
                    }, {
                        code: "ОК 02.",
                        cat: "ОК 02.",
                        desc: "Использовать современные средства поиска, анализа и интерпретации информации и информационные технологии для выполнения задач профессиональной деятельности."
                    }, {
                        code: "ОК 03.",
                        cat: "ОК 03.",
                        desc: "Планировать и реализовывать собственное профессиональное и личностное развитие, предпринимательскую деятельность в профессиональной сфере, использовать знания по правовой и финансовой грамотности в различных жизненных ситуациях."
                    }, {
                        code: "ОК 04.",
                        cat: "ОК 04.",
                        desc: "Эффективно взаимодействовать и работать в коллективе и команде."
                    }, {
                        code: "ОК 05.",
                        cat: "ОК 05.",
                        desc: "Осуществлять устную и письменную коммуникацию на государственном языке Российской Федерации с учетом особенностей социального и культурного контекста."
                    }, {
                        code: "ОК 06.",
                        cat: "ОК 06.",
                        desc: "Проявлять гражданско-патриотическую позицию, демонстрировать осознанное поведение на основе традиционных российских духовно-нравственных ценностей, в том числе с учетом гармонизации межнациональных и межрелигиозных отношений, применять стандарты антикоррупционного поведения."
                    }, {
                        code: "ОК 07.",
                        cat: "ОК 07.",
                        desc: "Содействовать сохранению окружающей среды, ресурсосбережению, применять знания об изменении климата, принципы бережливого производства, эффективно действовать в чрезвычайных ситуациях."
                    }, {
                        code: "ОК 08.",
                        cat: "ОК 08.",
                        desc: "Использовать средства физической культуры для сохранения и укрепления здоровья в процессе профессиональной деятельности и поддержания необходимого уровня физической подготовленности."
                    }, {
                        code: "ОК 09.",
                        cat: "ОК 09.",
                        desc: "Пользоваться профессиональной документацией на государственном и иностранном языках."
                    }],
                    OPK: [{
                        code: "ПК 1.1.",
                        cat: "ПК 1.1.",
                        desc: "Осуществлять сопровождение, в том числе документационное, процедуры закупок."
                    }, {
                        code: "ПК 1.2.",
                        cat: "ПК 1.2.",
                        desc: "Организовывать процессы складирования и грузоперевозки на складе."
                    }, {
                        code: "ПК 1.3.",
                        cat: "ПК 1.3.",
                        desc: "Осуществлять документационное сопровождение складских операций."
                    }, {
                        code: "ПК 1.4.",
                        cat: "ПК 1.4.",
                        desc: "Применять модели управления и методы анализа и регулирования запасами"
                    }, {
                        code: "ПК 2.1.",
                        cat: "ПК 2.1.",
                        desc: "Сопровождать логистические процессы в производстве, сбыте и распределении."
                    }, {
                        code: "ПК 2.2.",
                        cat: "ПК 2.2.",
                        desc: "Рассчитывать и анализировать логистические издержки в производстве и распределении."
                    }, {
                        code: "ПК 3.1.",
                        cat: "ПК 3.1.",
                        desc: "Планировать, подготавливать и осуществлять процесс перевозки грузов."
                    }, {
                        code: "ПК 3.2.",
                        cat: "ПК 3.2.",
                        desc: "Определять параметры логистического сервиса."
                    }, {
                        code: "ПК 3.3.",
                        cat: "ПК 3.3.",
                        desc: "Оценивать качество логистического сервиса."
                    }, {
                        code: "ПК 4.1.",
                        cat: "ПК 4.1.",
                        desc: "Планировать работу элементов логистической системы."
                    }, {
                        code: "ПК 4.2.",
                        cat: "ПК 4.2.",
                        desc: "Владеть методологией оценки эффективности функционирования элементов логистической системы."
                    }, {
                        code: "ПК 4.3.",
                        cat: "ПК 4.3.",
                        desc: "Составлять программу и осуществлять мониторинг показателей работы на уровне подразделения (участка) логистической системы."
                    }],
                },
                '54.02.01': {
                    UK: [{
                        code: "ОК 01.",
                        cat: "ОК 01.",
                        desc: "Выбирать способы решения задач профессиональной деятельности, применительно к различным контекстам."
                    }, {
                        code: "ОК 02.",
                        cat: "ОК 02.",
                        desc: "Использовать современные средства поиска, анализа и интерпретации информации и информационные технологии для выполнения задач профессиональной деятельности."
                    }, {
                        code: "ОК 03.",
                        cat: "ОК 03.",
                        desc: "Планировать и реализовывать собственное профессиональное и личностное развитие, предпринимательскую деятельность в профессиональной сфере, использовать знания по правовой и финансовой грамотности в различных жизненных ситуациях."
                    }, {
                        code: "ОК 04.",
                        cat: "ОК 04.",
                        desc: "Эффективно взаимодействовать и работать в коллективе и команде."
                    }, {
                        code: "ОК 05.",
                        cat: "ОК 05.",
                        desc: "Осуществлять устную и письменную коммуникацию на государственном языке Российской Федерации с учетом особенностей социального и культурного контекста."
                    }, {
                        code: "ОК 06.",
                        cat: "ОК 06.",
                        desc: "Проявлять гражданско-патриотическую позицию, демонстрировать осознанное поведение на основе традиционных российских и духовно-нравственных ценностей, в том числе с учетом гармонизации межнациональных и межрелигиозных отношений, применять стандарты антикоррупционного поведения."
                    }, {
                        code: "ОК 07.",
                        cat: "ОК 07.",
                        desc: "Содействовать сохранению окружающей среды, ресурсосбережению, применять знания об изменении климата, принципы бережливого производства, эффективно действовать в чрезвычайных ситуациях."
                    }, {
                        code: "ОК 08.",
                        cat: "ОК 08.",
                        desc: "Использовать средства физической культуры для сохранения и укрепления здоровья в процессе профессиональной деятельности и поддержания необходимого уровня физической подготовленности."
                    }, {
                        code: "ОК 09.",
                        cat: "ОК 09.",
                        desc: "Пользоваться профессиональной документацией на государственном и иностранном языках."
                    }],
                    OPK: [{
                        code: "ПК 1.1.",
                        cat: "ПК 1.1.",
                        desc: "Разрабатывать техническое задание согласно требованиям заказчика."
                    }, {
                        code: "ПК 1.2.",
                        cat: "ПК 1.2.",
                        desc: "Проводить предпроектный анализ для разработки дизайн-проектов."
                    }, {
                        code: "ПК 1.3.",
                        cat: "ПК 1.3.",
                        desc: "Осуществлять процесс дизайнерского проектирования с применением специализированных компьютерных программ."
                    }, {
                        code: "ПК 1.4.",
                        cat: "ПК 1.4.",
                        desc: "Производить расчеты технико-экономического обоснования предлагаемого проекта."
                    }, {
                        code: "ПК 2.1.",
                        cat: "ПК 2.1.",
                        desc: "Разрабатывать технологическую карту изготовления изделия."
                    }, {code: "ПК 2.2.", cat: "ПК 2.2.", desc: "Выполнять технические чертежи."}, {
                        code: "ПК 2.3.",
                        cat: "ПК 2.3.",
                        desc: "Выполнять экспериментальные образцы объекта дизайна или его отдельные элементы в макете или материале в соответствии с техническим заданием (описанием)."
                    }, {
                        code: "ПК 2.4.",
                        cat: "ПК 2.4.",
                        desc: "Доводить опытные образцы промышленной продукции до соответствия технической документации."
                    }, {
                        code: "ПК 2.5.",
                        cat: "ПК 2.5.",
                        desc: "Разрабатывать эталон (макет в масштабе) изделия."
                    }, {
                        code: "ПК 3.1.",
                        cat: "ПК 3.1.",
                        desc: "Контролировать промышленную продукцию и предметно-пространственные комплексы на предмет соответствия требованиям стандартизации и сертификации."
                    }, {
                        code: "ПК 3.2.",
                        cat: "ПК 3.2.",
                        desc: "Осуществлять авторский надзор за реализацией художественно-конструкторских (дизайнерских) решений при изготовлении и доводке опытных образцов промышленной продукции, воплощении предметно-пространственных комплексов."
                    }, {code: "ПК 4.1.", cat: "ПК 4.1.", desc: "Планировать работу коллектива."}, {
                        code: "ПК 4.2.",
                        cat: "ПК 4.2.",
                        desc: "Составлять конкретные технические задания для реализации дизайн-проекта на основе технологических карт."
                    }, {
                        code: "ПК 4.3.",
                        cat: "ПК 4.3.",
                        desc: "Контролировать сроки и качество выполненных заданий. "
                    }, {
                        code: "ПК 4.4.",
                        cat: "ПК 4.4.",
                        desc: "Осуществлять прием и сдачу работы в соответствии с техническим заданием."
                    }, {
                        code: "ПК.5.1",
                        cat: "ПК.5.1",
                        desc: "Выполнять шрифтовые работы."
                    }, {

                        cat: "ДПК.5.2", desc: "Выполнять оформительские работы."
                    }],

                },
                '08.02.13': {
                    UK: [{
                        code: "ОК 01.",
                        cat: "ОК 01.",
                        desc: "Выбирать способы решения задач профессиональной деятельности, применительно к различным контекстам."
                    }, {
                        code: "ОК 02.",
                        cat: "ОК 02.",
                        desc: "Использовать современные средства поиска, анализа и интерпретации информации, и информационные технологии для выполнения задач профессиональной деятельности."
                    }, {
                        code: "ОК 03.",
                        cat: "ОК 03.",
                        desc: "Планировать и реализовывать собственное профессиональное и личностное развитие, предпринимательскую деятельность в профессиональной сфере, использовать знания по финансовой грамотности в различных жизненных ситуациях."
                    }, {
                        code: "ОК 04.",
                        cat: "ОК 04.",
                        desc: "Эффективно взаимодействовать и работать в коллективе и команде."
                    }, {
                        code: "ОК 05.",
                        cat: "ОК 05.",
                        desc: "Осуществлять устную и письменную коммуникацию на государственном языке Российской Федерации с учетом особенностей социального и культурного контекста."
                    }, {
                        code: "ОК 06.",
                        cat: "ОК 06.",
                        desc: "Проявлять гражданско-патриотическую позицию, демонстрировать осознанное поведение на основе традиционных российских духовно-нравственных ценностей в том числе с учетом гармонизации межнациональных и межрелигиозных отношений, применять стандарты антикоррупционного поведения."
                    }, {
                        code: "ОК 07.",
                        cat: "ОК 07.",
                        desc: "Содействовать сохранению окружающей среды, ресурсосбережению, применять знания об изменении климата, принципы бережливого производства, эффективно действовать в чрезвычайных ситуациях."
                    }, {
                        code: "ОК 08.",
                        cat: "ОК 08.",
                        desc: "Использовать средства физической культуры для сохранения и укрепления здоровья в процессе профессиональной деятельности и поддержания необходимого уровня физической подготовленности."
                    }, {
                        code: "ОК 09.",
                        cat: "ОК 09.",
                        desc: "Пользоваться профессиональной документацией на государственном и иностранном языках."
                    }],
                    OPK: [{
                        code: "ПК 1.1.",
                        cat: "ПК 1.1.",
                        desc: "Выполнять подготовительные работы при монтаже систем отопления, водоснабжения, канализации и водостоков."
                    }, {
                        code: "ПК 1.2.",
                        cat: "ПК 1.2.",
                        desc: "Выполнять монтаж систем отопления, водоснабжения, канализации и водостоков"
                    }, {
                        code: "ПК 1.3.",
                        cat: "ПК 1.3.",
                        desc: "Проводить и обрабатывать результаты испытаний систем отопления, водоснабжения, канализации и водостоков."
                    }, {
                        code: "ПК 1.4.",
                        cat: "ПК 1.4.",
                        desc: "Устранять неисправности систем центрального отопления, водоснабжения, канализации и водостоков при испытаниях."
                    }, {
                        code: "ПК 2.1.",
                        cat: "ПК 2.1.",
                        desc: "Выполнять подготовительные работы при монтаже систем вентиляции, кондиционирования воздуха"
                    }, {
                        code: "ПК 2.2.",
                        cat: "ПК 2.2.",
                        desc: "Выполнять монтаж систем вентиляции, кондиционирования воздуха."
                    }, {
                        code: "ПК 2.3.",
                        cat: "ПК 2.3.",
                        desc: "Проводить и обрабатывать результаты испытаний смонтированных систем вентиляции, кондиционирования воздуха."
                    }, {
                        code: "ПК 2.4.",
                        cat: "ПК 2.4.",
                        desc: "Регулировать смонтированные системы вентиляции, кондиционирования воздуха для достижения проектных и паспортных характеристик"
                    }, {
                        code: "ПК 3.1.",
                        cat: "ПК 3.1.",
                        desc: "Выполнять подготовительные и сопутствующие работы при техническом обслуживании и текущем ремонте инженерных систем отопления, водоснабжения, водоотведения и систем вентиляции, кондиционирования воздуха гражданских зданий."
                    }, {
                        code: "ПК.3.2",
                        cat: "ПК.3.2",
                        desc: "Выполнить периодическое техническое обслуживание, проводить текущие ремонтные работы инженерных систем отопления, водоснабжения, водоотведения и систем вентиляции, кондиционирования воздуха гражданских зданий."
                    }, {
                        code: "ПК 4.1.",
                        cat: "ПК 4.1.",
                        desc: "Организовывать устранение аварийных ситуаций инженерных систем отопления, водоснабжения, водоотведения и систем вентиляции, кондиционирования воздуха гражданских зданий."
                    }, {
                        code: "ПК 4.2.",
                        cat: "ПК 4.2.",
                        desc: "Организовывать работы по технической эксплуатации и содержанию инженерных систем отопления, водоснабжения, водоотведения и систем вентиляции, кондиционирования воздуха гражданских зданий."
                    }, {
                        code: "ПК.5.1",
                        cat: "ПК.5.1",
                        desc: "Осуществлять прием и подготовку оборудования систем вентиляции и кондиционирования воздуха"
                    }, {
                        code: "ПК.5.2",
                        cat: "ПК.5.2",
                        desc: "Осуществлять монтаж систем вентиляции и кондиционирования воздуха"
                    }, {
                        code: "ПК.6.1",
                        cat: "ПК.6.1",
                        desc: "Коммуникация и кооперация в цифровой среде."
                    }, {
                        code: "ПК.6.2",
                        cat: "ПК.6.2",
                        desc: "Саморазвитие в условиях неопределенности."
                    }, {
                        code: "ПК.6.3",
                        cat: "ПК.6.3",
                        desc: "Креативное мышление."
                    }, {
                        code: "ПК.6.4",
                        cat: "ПК.6.4",
                        desc: "Управление информацией и данными."
                    },{
                        code: "ПК.6.5",
                        cat: "ПК.6.5",
                        desc: "Критическое мышление в цифровой среде."
                    }]
                },
                '29.02.10': {
                    UK: [{
                        code: "ОК 01.",
                        cat: "ОК 01.",
                        desc: "Выбирать способы решения задач профессиональной деятельности применительно к различным контекстам."
                    }, {
                        code: "ОК 02.",
                        cat: "ОК 02.",
                        desc: "Использовать современные средства поиска, анализа и интерпретации информации и информационные технологии для выполнения задач профессиональной деятельности."
                    }, {
                        code: "ОК 03.",
                        cat: "ОК 03.",
                        desc: "Планировать и реализовывать собственное профессиональное и личностное развитие, предпринимательскую деятельность в профессиональной сфере, использовать знания по правовой и  финансовой грамотности в различных жизненных ситуациях."
                    }, {
                        code: "ОК 04.",
                        cat: "ОК 04.",
                        desc: "Эффективно взаимодействовать и работать в коллективе и команде."
                    }, {
                        code: "ОК 05.",
                        cat: "ОК 05.",
                        desc: "Осуществлять устную и письменную коммуникацию на государственном языке Российской Федерации с учетом особенностей социального и культурного контекста."
                    }, {
                        code: "ОК 06.",
                        cat: "ОК 06.",
                        desc: "Проявлять гражданско-патриотическую позицию, демонстрировать осознанное поведение на основе традиционных российских духовно-нравственных ценностей, в том числе с учетом гармонизации межнациональных и межрелигиозных отношений, применять стандарты антикоррупционного поведения."
                    }, {
                        code: "ОК 07.",
                        cat: "ОК 07.",
                        desc: "Содействовать сохранению окружающей среды, ресурсосбережению, применять знания об изменении климата, принципы бережливого производства, эффективно действовать в чрезвычайных ситуациях."
                    }, {
                        code: "ОК 08.",
                        cat: "ОК 08.",
                        desc: "Использовать средства физической культуры для сохранения и укрепления здоровья в процессе профессиональной деятельности и поддержания необходимого уровня физической подготовленности."
                    }, {
                        code: "ОК 09.",
                        cat: "ОК 09.",
                        desc: "Пользоваться профессиональной документацией на государственном и иностранном языках."
                    }],
                    OPK: [{
                        code: "ПК 1.1.",
                        cat: "ПК 1.1.",
                        desc: "Создавать технические рисунки и эскизы изделий, модельных рядов, коллекций, с применением различных источников с учетом свойств материалов и особенностей целевого рынка."
                    }, {
                        code: "ПК 1.2.",
                        cat: "ПК 1.2.",
                        desc: "Использовать элементы и принципы дизайна при проектировании швейных изделий с учетом модных направлений, стилей, тенденций и культурных традиций."
                    }, {
                        code: "ПК 1.3.",
                        cat: "ПК 1.3.",
                        desc: "Сочетать цвета, стили, мотивы, материалы и аксессуары для создания гармоничных моделей."
                    }, {
                        code: "ПК 1.4.",
                        cat: "ПК 1.4.",
                        desc: "Создавать мудборды, трендборды с использованием актуальных дизайнерских решений и доносить идеи до клиента, в том числе с применением компьютерной графики."
                    }, {
                        code: "ПК 1.5.",
                        cat: "ПК 1.5.",
                        desc: "Создавать прототипы и образцы изделий методом макетирования."
                    }, {
                        code: "ПК 1.6.",
                        cat: "ПК 1.6.",
                        desc: "Осуществлять авторский надзор за реализацией художественного решения модели на всех этапах производства изделий."
                    }, {
                        code: "ПК 2.1.",
                        cat: "ПК 2.1.",
                        desc: "Выполнять чертежи базовых конструкций изделий."
                    }, {
                        code: "ПК 2.2.",
                        cat: "ПК 2.2.",
                        desc: "Моделировать изделия различных видов на базовой основе."
                    }, {
                        code: "ПК 2.3.",
                        cat: "ПК 2.3.",
                        desc: "Изготавливать лекала и выполнять их градацию."
                    }, {
                        code: "ПК 2.4.",
                        cat: "ПК 2.4.",
                        desc: "Разрабатывать конструкторскую документацию к внедрению на проектируемое изделие."
                    }, {
                        code: "ПК 2.5.",
                        cat: "ПК 2.5.",
                        desc: "Осуществлять контроль за реализацией конструкторских решений модели."
                    }, {
                        code: "ПК 3.1.",
                        cat: "ПК 3.1.",
                        desc: "Выбирать рациональные способы технологии и технологические режимы производства швейных изделий."
                    }, {
                        code: "ПК 3.2.",
                        cat: "ПК 3.2.",
                        desc: "Составлять технологические карты (последовательности) выполняемых операций на новые модели швейных изделий в соответствии с нормативной документацией."
                    }, {
                        code: "ПК 3.3.",
                        cat: "ПК 3.3.",
                        desc: "Осуществлять подбор оборудования при разработке технологических процессов."
                    }, {
                        code: "ПК 3.4.",
                        cat: "ПК 3.4.",
                        desc: "Выполнять экономичные раскладки лекал."
                    }, {
                        code: "ДПК.4.1",
                        cat: "ДПК.4.1",
                        desc: "Выполнять ремонт изделий бытовой и специальной одежды, домашнего текстиля и текстильной галантереи."
                    }, {
                        code: "ДПК.4.2",
                        cat: "ДПК.4.2",
                        desc: "Изготовлять изделий бытовой и специальной одежды, домашнего текстиля и текстильной галантереи."
                    }],
                },
            },
            basis_info: {
                '01.03.02':{
                    quality: 'Бакалавр',
                    basis_num: '9',
                    basis_date: '10.01.18'
                },
                '03.03.02':{
                    quality: 'Бакалавр',
                    basis_num: '891',
                    basis_date: '07.08.20'
                },
                '09.03.01':{
                    quality: 'Бакалавр',
                    basis_num: '929',
                    basis_date: '19.09.17'
                },
                '09.03.02':{
                    quality: 'Бакалавр',
                    basis_num: '926',
                    basis_date: '19.09.17'
                },
                '09.03.04':{
                    quality: 'Бакалавр',
                    basis_num: '920',
                    basis_date: '19.09.17'
                },
                '10.03.01':{
                    quality: 'Бакалавр',
                    basis_num: '1427',
                    basis_date: '17.11.20'
                },
                '13.03.01':{
                    quality: 'Бакалавр',
                    basis_num: '143',
                    basis_date: '28.02.18'
                },
                '13.03.02':{
                    quality: 'Бакалавр',
                    basis_num: '144',
                    basis_date: '28.02.18'
                },
                '15.03.04':{
                    quality: 'Бакалавр',
                    basis_num: '730',
                    basis_date: '09.08.21'
                },
                '18.03.01':{
                    quality: 'Бакалавр',
                    basis_num: '922',
                    basis_date: '07.08.20'
                },
                '18.04.01':{
                    quality: 'Магистр',
                    basis_num: '910',
                    basis_date: '07.08.20'
                },
                '20.03.01':{
                    quality: 'Бакалавр',
                    basis_num: '680',
                    basis_date: '25.05.20'
                },
                '24.03.01':{
                    quality: 'Бакалавр',
                    basis_num: '71',
                    basis_date: '05.02.18'
                },
                '29.03.05':{
                    quality: 'Бакалавр',
                    basis_num: '962',
                    basis_date: '22.09.17'
                },
                '37.03.01':{
                    quality: 'Бакалавр',
                    basis_num: '839',
                    basis_date: '29.07.20'
                },
                '38.03.01':{
                    quality: 'Бакалавр',
                    basis_num: '954',
                    basis_date: '12.08.20'
                },
                '38.03.02':{
                    quality: 'Бакалавр',
                    basis_num: '970',
                    basis_date: '12.08.20'
                },
                '38.03.04':{
                    quality: 'Бакалавр',
                    basis_num: '1016',
                    basis_date: '13.08.20'
                },
                '39.03.01':{
                    quality: 'Бакалавр',
                    basis_num: '75',
                    basis_date: '05.02.18'
                },
                '39.03.02':{
                    quality: 'Бакалавр',
                    basis_num: '76',
                    basis_date: '05.02.18'
                },
                '40.03.01':{
                    quality: 'Бакалавр',
                    basis_num: '1011',
                    basis_date: '13.08.20'
                },
                '41.03.01':{
                    quality: 'Бакалавр',
                    basis_num: '553',
                    basis_date: '15.06.17'
                },
                '42.03.01':{
                    quality: 'Бакалавр',
                    basis_num: '512',
                    basis_date: '08.06.17'
                },
                '42.03.02':{
                    quality: 'Бакалавр',
                    basis_num: '524',
                    basis_date: '08.06.17'
                },
                '43.03.02':{
                    quality: 'Бакалавр',
                    basis_num: '516',
                    basis_date: '08.06.17'
                },
                '43.03.03':{
                    quality: 'Бакалавр',
                    basis_num: '515',
                    basis_date: '08.06.17'
                },
                '44.03.01':{
                    quality: 'Бакалавр',
                    basis_num: '121',
                    basis_date: '22.02.18'
                },
                '44.03.02':{
                    quality: 'Бакалавр',
                    basis_num: '122',
                    basis_date: '22.02.18'
                },
                '44.03.05':{
                    quality: 'Бакалавр',
                    basis_num: '125',
                    basis_date: '22.02.18'
                },
                '45.03.01':{
                    quality: 'Бакалавр',
                    basis_num: '986',
                    basis_date: '12.08.20'
                },
                '45.03.02':{
                    quality: 'Бакалавр',
                    basis_num: '969',
                    basis_date: '12.08.20'
                },
                '45.03.03':{
                    quality: 'Бакалавр',
                    basis_num: '323',
                    basis_date: '24.04.18'
                },
                '46.03.01':{
                    quality: 'Бакалавр',
                    basis_num: '1291',
                    basis_date: '08.10.20'
                },
                '47.03.03':{
                    quality: 'Бакалавр',
                    basis_num: '974',
                    basis_date: '12.08.20'
                },
                '54.03.01':{
                    quality: 'Бакалавр',
                    basis_num: '1015',
                    basis_date: '13.08.20'
                },
                '58.03.01':{
                    quality: 'Бакалавр',
                    basis_num: '1051',
                    basis_date: '18.08.20'
                },
                '21.05.02':{
                    quality: 'Горный инженер - геолог',
                    basis_num: '953',
                    basis_date: '12.08.20'
                },
                '24.05.01':{
                    quality: 'Инженер',
                    basis_num: '964',
                    basis_date: '12.08.20'
                },
                '37.05.01':{
                    quality: 'Клинический психолог',
                    basis_num: '683',
                    basis_date: '26.05.20'
                },
                '38.05.01':{
                    quality: 'Экономист',
                    basis_num: '293',
                    basis_date: '14.04.21'
                },
                '38.05.02':{
                    quality: 'Специалист таможенного дела',
                    basis_num: '1453',
                    basis_date: '25.11.20'
                },
                '54.05.01':{
                    quality: 'Художник - проектировщик интерьера',
                    basis_num: '1009',
                    basis_date: '13.08.20'
                },
                '01.04.02':{
                    quality: 'Магистр',
                    basis_num: '13',
                    basis_date: '10.01.18'
                },
                '03.04.01':{
                    quality: 'Магистр',
                    basis_num: '898',
                    basis_date: '07.08.20'
                },
                '09.04.01':{
                    quality: 'Магистр',
                    basis_num: '918',
                    basis_date: '19.09.17'
                },
                '09.04.04':{
                    quality: 'Магистр',
                    basis_num: '932',
                    basis_date: '19.09.17'
                },
                '13.04.02':{
                    quality: 'Магистр',
                    basis_num: '147',
                    basis_date: '28.02.18'
                },
                '37.04.01':{
                    quality: 'Магистр',
                    basis_num: '841',
                    basis_date: '29.07.20'
                },
                '38.04.01':{
                    quality: 'Магистр',
                    basis_num: '939',
                    basis_date: '11.08.20'
                },
                '38.04.02':{
                    quality: 'Магистр',
                    basis_num: '952',
                    basis_date: '12.08.20'
                },
                '38.04.04':{
                    quality: 'Магистр',
                    basis_num: '1000',
                    basis_date: '13.08.20'
                },
                '39.04.02':{
                    quality: 'Магистр',
                    basis_num: '80',
                    basis_date: '05.02.18'
                },
                '40.04.01':{
                    quality: 'Магистр',
                    basis_num: '1451',
                    basis_date: '25.11.20'
                },
                '41.04.01':{
                    quality: 'Магистр',
                    basis_num: '648',
                    basis_date: '12.07.17'
                },
                '42.04.01':{
                    quality: 'Магистр',
                    basis_num: '528',
                    basis_date: '08.06.17'
                },
                '43.04.02':{
                    quality: 'Магистр',
                    basis_num: '556',
                    basis_date: '15.06.17'
                },
                '44.04.01':{
                    quality: 'Магистр',
                    basis_num: '126',
                    basis_date: '22.02.18'
                },
                '44.04.02':{
                    quality: 'Магистр',
                    basis_num: '127',
                    basis_date: '22.02.18'
                },
                '45.04.01':{
                    quality: 'Магистр',
                    basis_num: '980',
                    basis_date: '12.08.20'
                },
                '45.04.02':{
                    quality: 'Магистр',
                    basis_num: '992',
                    basis_date: '12.08.20'
                },
                '45.04.03':{
                    quality: 'Магистр',
                    basis_num: '993',
                    basis_date: '12.08.20'
                },
                '47.04.03':{
                    quality: 'Магистр',
                    basis_num: '968',
                    basis_date: '12.08.20'
                },
                '54.04.01':{
                    quality: 'Магистр',
                    basis_num: '1004',
                    basis_date: '13.08.20'
                },
                '1.3.8.':{
                    quality: '',
                    basis_num: '951',
                    basis_date: '20.10.21'
                },
                '1.2.2.':{
                    quality: '',
                    basis_num: '951',
                    basis_date: '20.10.21'
                },
                '1.6.10.':{
                    quality: '',
                    basis_num: '951',
                    basis_date: '20.10.21'
                },
                '2.4.3.':{
                    quality: '',
                    basis_num: '951',
                    basis_date: '20.10.21'
                },
                '5.3.4.':{
                    quality: '',
                    basis_num: '951',
                    basis_date: '20.10.21'
                },
                '5.2.3.':{
                    quality: '',
                    basis_num: '951',
                    basis_date: '20.10.21'
                },
                '5.1.1.':{
                    quality: '',
                    basis_num: '951',
                    basis_date: '20.10.21'
                },
                '5.8.7.':{
                    quality: '',
                    basis_num: '951',
                    basis_date: '20.10.21'
                },
                '5.9.1.':{
                    quality: '',
                    basis_num: '951',
                    basis_date: '20.10.21'
                },
                '5.9.8.':{
                    quality: '',
                    basis_num: '951',
                    basis_date: '20.10.21'
                },
                '5.7.9.':{
                    quality: '',
                    basis_num: '951',
                    basis_date: '20.10.21'
                },
                '5.12.3.':{
                    quality: '',
                    basis_num: '951',
                    basis_date: '20.10.21'
                },
                '08.02.13':{
                    quality: 'Техник',
                    basis_num: '1094',
                    basis_date: '12.12.2022'
                },
                '09.02.01':{
                    quality: 'Специалист по компьютерным системам',
                    basis_num: '362',
                    basis_date: '25.05.2022'
                },
                '09.02.07':{
                    quality: 'Программист',
                    basis_num: '1547',
                    basis_date: '09.12.2016'
                },
                '10.02.04':{
                    quality: 'Техник по защите информации',
                    basis_num: '1551',
                    basis_date: '09.12.2016'
                },
                '13.02.11':{
                    quality: 'Техник',
                    basis_num: '1196',
                    basis_date: '07.12.2017'
                },
                '13.02.13':{
                    quality: 'Техник',
                    basis_num: '797',
                    basis_date: '27.10.2023'
                },
                '15.02.13':{
                    quality: 'Техник',
                    basis_num: '1562',
                    basis_date: '09.12.2016'
                },
                '18.02.12':{
                    quality: 'Техник',
                    basis_num: '1554',
                    basis_date: '09.12.2016'
                },
                '20.04.01': {
                    quality: 'Магистр',
                    basis_num: '678',
                    basis_date: '25.05.2020'
                },
                '21.02.13':{
                    quality: 'Техник-геолог',
                    basis_num: '611',
                    basis_date: '26.07.2022'
                },
                '27.02.06':{
                    quality: 'Техник-метролог',
                    basis_num: '1570',
                    basis_date: '09.12.2016'
                },
                '29.02.04':{
                    quality: 'Технолог-конструктор',
                    basis_num: '534',
                    basis_date: '15.05.2014'
                },
                '29.02.10':{
                    quality: 'Технолог-конструктор',
                    basis_num: '443',
                    basis_date: '14.06.2022'
                },
                '38.02.01':{
                    quality: 'Бухгалтер',
                    basis_num: '437',
                    basis_date: '24.06.2024'
                },
                '38.02.03':{
                    quality: 'Операционный логист',
                    basis_num: '257',
                    basis_date: '21.04.2022'
                },
                '40.02.01':{
                    quality: 'Юрист',
                    basis_num: '508',
                    basis_date: '12.05.2014'
                },
                '40.02.04':{
                    quality: 'Юрист',
                    basis_num: '798',
                    basis_date: '27.10.2023'
                },
                '43.02.10':{
                    quality: 'Специалист по туризму',
                    basis_num: '474',
                    basis_date: '07.05.2014'
                },
                '43.02.16':{
                    quality: 'Специалист по туризму',
                    basis_num: '1100',
                    basis_date: '12.12.2022'
                },
                '54.02.01':{
                    quality: 'Дизайнер',
                    basis_num: '308',
                    basis_date: '05.05.2022'
                },
            },
        }
    }
}